<template>
  <div>
    <v-row>
      <v-col md="12" lg="12" xl="12" cols="12" v-if="dialog == true">
        <loadingComponent
          @closeDialog="dialog = $event"
          :messageDialogeProps="messageDialogeError"
          :dialogProps="dialog"
          :loadingProps="loading"
          :errorProps="error"
        />
      </v-col>
    </v-row>
    <v-row v-if="vraiSiret == true">
        <h4 class="ma-0 pa-0" style="padding-left: 12px !important;">{{raison}}</h4>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-subheader class="ma-0 pa-0">Score d'entreprise:</v-subheader>
        <v-divider class="ma-0 pa-0"></v-divider>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3" xl="3">
        <div>
          <v-card-title class="justify-start">
            <v-avatar class="mr-2" size="30" rounded>
              <img
                alt="credit safe score"
                src="../../../assets/images/logos/logo-credit-safe.png"
              />
            </v-avatar>
            creditsafe :
            <span class="ml-2 font-weight-black">
              {{
                isNaN(this.scoreCreditSafe)
                  ? "info manquante"
                  : this.scoreCreditSafe + "/100"
              }}
            </span>
          </v-card-title>
        </div>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3" xl="3">
        <div>
          <v-card-title class="justify-start">
            <v-avatar class="mr-2" height="30" width="61" rounded>
              <img alt="credit safe score" src="../../../assets/logoElliPro.png" />
            </v-avatar>
            Elli Pro :
            <span class="ml-2 font-weight-black">
              {{
                isNaN(this.scoreEllipro) ? "info manquante" : this.scoreEllipro + "/10"
              }}
            </span>
          </v-card-title>
        </div>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-if="this.ceeExonere != null">
        <div>
          <v-card-title class="justify-start">
            <v-avatar class="mr-2" height="40" width="40" rounded>
              <img alt="credit safe score" src="../../../assets/CEE.png" />
            </v-avatar>
            CEE :
            <span class="ml-2 font-weight-black">
              {{ this.ceeExonere ? "Non Exonéré" : "Exonéré" }}
            </span>
          </v-card-title>
        </div>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-if="this.codeNaf != null">
        <div>
          <v-card-title class="justify-start">
            Code Naf:
            <span class="ml-2 font-weight-black">
              {{ this.codeNaf }}
            </span>
          </v-card-title>
        </div>
      </v-col>
    </v-row>
    <!-- form de siret -->
    <v-form ref="formeSiret" lazy-validation>
      <v-subheader>Recherche par SIRET ou Raison sociale :</v-subheader>
      <v-divider class="mb-12"></v-divider>
      <v-row>
        <v-col cols="12" sm="11" md="6" lg="6" xl="6">
          <v-combobox
            :search-input.sync="valueRechercheSiret"
            @input="getPropositionSiretOrName"
            v-model="valueRechercheSiret"
            outlined
            :rules="[rules.required(`un siret ou une raison sociale valide`)]"
            :items="listSociete"
            :return-object="true"
            label="Siret ou Raison sociale"
            @keydown.enter.prevent="getPropositionSiretOrName"
          ></v-combobox>
        </v-col>
        <v-col cols="12" sm="8" md="6" lg="6" xl="6">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex justify-content-center"
            >
              <v-btn
                depressed
                elevation="1"
                large
                @click="getListeCompteurs"
                class="responsive-margin text-white"
                :color="$colors[0]"
                width="100%"
                height="50px"
              >
                Rechercher
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>

    <!--form details compteur -->
    <v-form ref="formGeneral" lazy-validation v-if="vraiSiret == true || isHistorique == true">
      <v-row>
        <v-col cols="12" sm="11" md="6" lg="6" xl="6">
          <v-form ref="formGetConsommation" lazy-validation v-if="vraiSiret == true || isHistorique == true">
            <v-select
              required
              outlined
              multiple
              v-model="listCompteurSelected"
              :items="listCompteur"
              label="Numéro de compteur"
              :rules="[$rules.required, validateSelectionCompteur]"
            ></v-select>
          </v-form>
        </v-col>
        <v-col cols="12" sm="8" md="6" lg="6" xl="6">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex justify-content-center"
            >
              <v-btn
                :disabled="listCompteurSelected.length == 0 ? true : false"
                v-if="listCompteur.length > 0"
                @click="getCompteurData"
                elevation="1"
                depressed
                large
                :color="$colors[0]"
                class="responsive-margin text-white"
                width="100%"
                height="50px"
              >
                Recuperer Consommations
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex justify-content-center"
            >
              <v-btn
                v-if="enedisRecherche"
                @click="openModalFornisseurActuelleFnc"
                elevation="1"
                depressed
                large
                :color="$colors[0]"
                class="responsive-margin text-white"
                width="100%"
                height="50px"
              >
                <v-icon left>{{
                  openModalFornisseurActuelle ? "mdi-minus" : "mdi-plus"
                }}</v-icon>
                Fournisseur
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div v-if="listDonnerCotation.length > 0">
        <v-subheader class="ma-0">Compteurs :</v-subheader>
        <v-divider class="ma-0 pa-0"></v-divider>
        <small style="font-size: 12px; color: gray">
          Toutes les consommations sont exprimées en MWh.</small
        >
        <v-row class="ma-0 mt-4" align="center" justify="end">
          <v-col class="pl-0" cols="auto">
            <v-text-field
              type="date"
              outlined
              dense
              hide-details
              label="Début de Contrat"
              v-model="dateDebut"
              :min="minDebutContrat"
              :max="maxDateDebutContrat"
            />
          </v-col>
          <v-col class="pl-0" cols="auto">
            <v-text-field
              type="date"
              outlined
              dense
              hide-details
              label="Fin de Contrat"
              v-model="dateFin"
              :min="minDebutFinContrat"
              :max="maxDateFinContrat"
            />
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              :color="$colors[0]"
              class="text-white"
              @click="applyDatesToAllCompteurs"
            >
              Appliquer à tous
            </v-btn>
          </v-col>
        </v-row>
        <div class="table-compteurs-wrapper">
          <table class="my-4">
            <thead>
              <tr>
                <th
                  style="
                    border: 1px solid gray;
                    width: 10vw;
                    height: 50px;
                    background-color: #2562eb;
                    color: white;
                    text-align: center;
                    font-weight: 500;
                  "
                  v-for="header in listHeaders"
                >
                  {{ header }}
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                style="text-align: center"
                v-for="(compteurLine, index) in listDonnerCotation"
              >
                <td style="border: 1px solid gray">
                  {{ compteurLine.numCompteur }}<br />
                  <v-tooltip
                    bottom
                    style="z-index: 1000"
                    v-if="compteurLine.resultatEnedis.mesuresInfo[0].nbrMonth < 12"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="td-table"
                        v-bind="attrs"
                        v-on="on"
                        style="height: 25px; width: 25px"
                        color="#EED202"
                        >mdi-alert</v-icon
                      >
                    </template>
                    <span style="color: white"
                      >Attention : les données Enedis ont moins d'un an</span
                    >
                  </v-tooltip>
                  <div v-if="getServiceCategory(compteurLine)" class="category-info">
                    {{ getServiceCategory(compteurLine) }}
                  </div>


                </td>
                <td style="border: 1px solid gray">
                  <v-select
                    class="pa-4"
                    v-model="compteurLine.optionTarifaire"
                    @change="changeOptionTarifaire(compteurLine)"
                    :items="optionsTarifaires"
                    :rules="[required('Option Tarifaire')]"
                    :disabled="
                      compteurLine.resultatEnedisTechnique &&
                      compteurLine.optionTarifaire != null
                    "
                    outlined
                    dense
                    hide-details
                  />
                  <v-select
                    v-if="
                      compteurLine.optionTarifaire == 'BTINFMU4' ||
                      compteurLine.optionTarifaire == 'BTINFCU4'
                    "
                    v-model="compteurLine.parametreCompteur"
                    @change="
                      changeOptionCalculeBtinf(
                        compteurLine,
                        compteurLine.parametreCompteur
                      )
                    "
                    :items="[
                      { text: '4 POSTES', value: 'C5C4' },
                      { text: 'HP/HC', value: 'C5HP' },
                      { text: 'Base', value: 'C5BASE' },
                    ]"
                    outlined
                    dense
                    hide-details
                    class="pa-4"
                  />
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    class="pa-4"
                    required
                    outlined
                    dense
                    v-model="compteurLine.puissanceSouscrite"
                    hide-details
                    :disabled="
                      compteurLine.resultatEnedisTechnique &&
                      compteurLine.puissanceSouscrite != null
                    "
                    :rules="[required('la Puisance souscrite')]"
                  ></v-text-field>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    class="pa-4"
                    v-if="compteurLine.parametreCompteur == 'C5BASE'"
                    type="number"
                    step="0.001"
                    @input="calculeSommeCotation(compteurLine)"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CABASE"
                    hide-details
                    :rules="[required('une consommation (CABASE) valide')]"
                  ></v-text-field>
                  <v-text-field
                    class="pa-4"
                    v-else-if="
                      compteurLine.parametreCompteur == 'C3' ||
                      compteurLine.parametreCompteur == 'C4' ||
                      compteurLine.parametreCompteur == 'C5C4'
                    "
                    type="number"
                    step="0.001"
                    required
                    @input="calculeSommeCotation(compteurLine)"
                    outlined
                    dense
                    v-model="compteurLine.CAHPH"
                    hide-details
                    :rules="[required('une consommation CONSOMMATION (HPH) valide')]"
                  ></v-text-field>
                  <v-text-field
                    class="pa-4"
                    v-else-if="compteurLine.parametreCompteur == 'C5HP'"
                    type="number"
                    @input="calculeSommeCotation(compteurLine)"
                    step="0.001"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CAHP"
                    hide-details
                    :rules="[required('une consommation (HP) valide')]"
                  ></v-text-field>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    v-if="
                      compteurLine.parametreCompteur == 'C3' ||
                      compteurLine.parametreCompteur == 'C4' ||
                      compteurLine.parametreCompteur == 'C5C4'
                    "
                    class="pa-4"
                    type="number"
                    step="0.001"
                    @input="calculeSommeCotation(compteurLine)"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CAHCH"
                    hide-details
                    :rules="[required('une consommation (HCH) valide')]"
                  ></v-text-field>
                  <v-text-field
                    v-else-if="compteurLine.parametreCompteur == 'C5HP'"
                    class="pa-4"
                    type="number"
                    @input="calculeSommeCotation(compteurLine)"
                    step="0.001"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CAHC"
                    hide-details
                    :rules="[required('une consommation (HC) valide')]"
                  ></v-text-field>
                  <span v-else>---</span>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    v-if="
                      compteurLine.parametreCompteur == 'C3' ||
                      compteurLine.parametreCompteur == 'C4' ||
                      compteurLine.parametreCompteur == 'C5C4'
                    "
                    class="pa-4"
                    type="number"
                    step="0.001"
                    @input="calculeSommeCotation(compteurLine)"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CAHPE"
                    hide-details
                    :rules="[required('une consommation (HPE) valide')]"
                  ></v-text-field>
                  <span v-else>---</span>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    v-if="
                      compteurLine.parametreCompteur == 'C3' ||
                      compteurLine.parametreCompteur == 'C4' ||
                      compteurLine.parametreCompteur == 'C5C4'
                    "
                    class="pa-4"
                    type="number"
                    step="0.001"
                    required
                    @input="calculeSommeCotation(compteurLine)"
                    outlined
                    dense
                    v-model="compteurLine.CAHCE"
                    hide-details
                    :rules="[required('une consommation (HCE) valide')]"
                  ></v-text-field>
                  <span v-else>---</span>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    v-if="compteurLine.parametreCompteur == 'C3'"
                    class="pa-4"
                    type="number"
                    step="0.001"
                    @input="calculeSommeCotation(compteurLine)"
                    required
                    outlined
                    dense
                    v-model="compteurLine.CAP"
                    hide-details
                    :rules="[required('conso (P)')]"
                  ></v-text-field>
                  <span v-else>---</span>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    :disabled="true"
                    class="pa-4"
                    type="number"
                    required
                    outlined
                    dense
                    v-model="compteurLine.sommeConsomation"
                    hide-details
                  ></v-text-field>
                </td>
                <td style="border: 1px solid gray">
                  <p>{{ compteurLine.resultatEnedis.mesuresInfo[0].nbrMonth }}</p>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    class="pa-4"
                    type="date"
                    outlined
                    dense
                    hide-details
                    v-model="compteurLine.dateDebut"
                    :min="minDebutContrat"
                    :max="maxDateDebutContrat"
                  ></v-text-field>
                </td>
                <td style="border: 1px solid gray">
                  <v-text-field
                    class="pa-4"
                    type="date"
                    outlined
                    dense
                    hide-details
                    v-model="compteurLine.dateFin"
                    :min="minDebutFinContrat"
                    :max="maxDateFinContrat"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- marge et dates -->
      <v-row v-if="enedisRecherche == true" class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-0 pa-0">
          <v-subheader class="ma-0 pa-0">Détails de l'offre :</v-subheader>
          <v-divider class="ma-0 pa-0"></v-divider>
        </v-col>
        <!-- marge -->
        <v-col class="pl-0" cols="11" sm="4" md="3" lg="3" xl="3">
          <v-text-field
            type="number"
            step="0.001"
            max="45"
            min="2"
            required
            outlined
            v-model="marge"
            label="Marge"
            :rules="[required('une marge')]"
          ></v-text-field>
        </v-col>
        <v-col class="pl-0" cols="11" sm="4" md="3" lg="3" xl="3">
          <v-text-field
            type="number"
            step="0.001"
            max="45"
            required
            outlined
            v-model="margeAbo"
            value="0"
            label="Marge Abonnement"
            :rules="[required('une marge d\'abonnement')]"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <!-- pop up de fornisseur actuelle -->
    <v-dialog v-model="openModalFornisseurActuelle" persistent max-width="80%">
      <v-card>
        <v-toolbar :color="$colors[0]" class="text-white" dark>
          <span class="text-h6 pl-0">Informations Fournisseur</span>
        </v-toolbar>
        <v-form ref="formActuelle" class="pa-4">
          <v-row class="ma-0 pa-0">
            <v-col cols="11" sm="12" md="12" lg="12" xl="12" class="ma-0 pa-0">
              <v-subheader class="ma-0">Type de fournisseur :</v-subheader>
              <v-divider class="ma-0 pa-0"></v-divider>
              <v-row>
                <v-col cols="11" sm="5" md="5" lg="5" xl="5">
                  <v-radio-group v-model="autreFournisseur.typeFournisseur" row @change="selectedCompteursMulti = []; prixParGroupe = {}; dialogStep = 1">
                    <v-radio
                      v-if="listCompteurSelectedComputedFournisseurActuelle.length > 0 || editFournisseur == true"
                      :color="$colors[2]"
                      label="Fournisseur actuel"
                      value="Actuelle"
                      class="v-radio"
                    ></v-radio>
                    <v-radio
                      :color="$colors[2]"
                      label="Nouveau fournisseur"
                      value="Fournisseur"
                      class="v-radio"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>

            <!-- MULTI-SELECT MODE (Add flow) -->
            <v-col cols="5" v-if="!editFournisseur">
              <v-select
                v-if="autreFournisseur.typeFournisseur == 'Actuelle'"
                v-model="selectedCompteursMulti"
                :items="listCompteurSelectedComputedFournisseurActuelle"
                multiple
                chips
                deletable-chips
                outlined
                label="Sélectionner les compteurs"
                :rules="[v => (v && v.length > 0) || 'Sélectionnez au moins un compteur']"
                @change="onMultiCompteurChanged"
              ></v-select>
              <v-select
                v-else
                v-model="selectedCompteursMulti"
                :items="listCompteurSelected"
                multiple
                chips
                deletable-chips
                outlined
                label="Sélectionner les compteurs"
                :rules="[v => (v && v.length > 0) || 'Sélectionnez au moins un compteur']"
                @change="onMultiCompteurChanged"
              ></v-select>
              <div class="d-flex" style="gap: 8px; margin-top: -8px;">
                <v-btn
                  small
                  text
                  :color="$colors[0]"
                  @click="selectAllCompteurs"
                >
                  Tout sélectionner
                </v-btn>
                <v-btn
                  small
                  text
                  :color="$colors[0]"
                  :disabled="selectedCompteursMulti.length === 0"
                  @click="unselectAllCompteurs"
                >
                  Tout désélectionner
                </v-btn>
              </div>
            </v-col>

            <!-- SINGLE-SELECT MODE (Edit flow) -->
            <v-col cols="3" v-if="editFournisseur">
              <v-select
                v-if="autreFournisseur.typeFournisseur == 'Actuelle'"
                v-model="autreFournisseur.numCompteur"
                outlined
                :items="listCompteurSelected"
                @change="numCompteurChanged"
                :rules="[required('un numéro de compteur')]"
              ></v-select>
              <v-select
                v-else
                v-model="autreFournisseur.numCompteur"
                outlined
                :items="listCompteurSelected"
                @change="numCompteurChanged"
                :rules="[required('un numéro de compteur')]"
              ></v-select>
            </v-col>

            <!-- Suivant button (Add mode step 1) -->
            <v-col cols="12" v-if="!editFournisseur && dialogStep === 1">
              <v-btn
                :color="$colors[0]"
                class="text-white"
                :disabled="selectedCompteursMulti.length === 0"
                @click="dialogStep = 2"
              >
                Suivant
              </v-btn>
            </v-col>
          </v-row>

          <!-- Step 2: shared fields (visible in step 2 or edit mode) -->
          <v-row class="ma-0 pa-0" v-show="dialogStep === 2 || editFournisseur">
            <v-col cols="11" sm="12" md="12" lg="12" xl="12" class="ma-0 pa-0">
              <v-subheader class="ma-0">Informations du fournisseur :</v-subheader>
              <v-col class="pa-0" cols="11" sm="5" md="5" lg="5" xl="5">
                <v-radio-group v-model="autreFournisseur.turpeInclus" row>
                  <v-radio
                    :color="$colors[2]"
                    label="Turpe Inclus"
                    value="oui"
                    class="v-radio"
                  ></v-radio>
                  <v-radio
                    :color="$colors[2]"
                    label="Turpe non Inclus"
                    value="non"
                    class="v-radio"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="pa-0" cols="11" sm="5" md="5" lg="5" xl="5">
                <v-radio-group v-model="autreFournisseur.ajoutMarge" row>
                  <v-radio
                    :color="$colors[2]"
                    label="Marge non incluse"
                    :value="true"
                    class="v-radio"
                  ></v-radio>
                  <v-radio
                    :color="$colors[2]"
                    label="Marge Incluse"
                    :value="false"
                    class="v-radio"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-divider class="ma-0 pa-0"></v-divider>
            </v-col>
            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2">
              <v-select
                required
                outlined
                :rules="[required('un fournisseur valide')]"
                v-model="autreFournisseur.fournisseur"
                :items="optionsFournisseurs"
                item-text="nom_fournisseur"
                item-value="key"
                label="Nom fournisseur"
              ></v-select>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="autreFournisseur.typeOffre != 'pré-écrêté'"
            >
              <v-select
                required
                outlined
                :rules="[required(`un type d'offre valide`), rules.Length]"
                v-model="autreFournisseur.typeOffre"
                :items="['Arenh', 'Fixe', 'pré-écrêté','Prix-indexé', 'TRV', 'Sur-mesure']"
                label="type d'offre"
              ></v-select>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="autreFournisseur.typeOffre == 'pré-écrêté'"
            >
              <v-select
                required
                outlined
                :rules="[required(`un type d'offre valide`), rules.Length]"
                v-model="autreFournisseur.typeOffre"
                :items="['Arenh', 'Fixe', 'pré-écrêté','Prix-indexé','TRV', 'Sur-mesure']"
                label="type d'offre"
              ></v-select>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="autreFournisseur.typeOffre == 'pré-écrêté'"
            >
              <v-checkbox
                v-model="autreFournisseur.Classique"
                label="Classique"
                value="Classique"
              ></v-checkbox>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                autreFournisseur.typeOffre == 'pré-écrêté' &&
                (autreFournisseur.Classique || []).indexOf('Classique') == -1
              "
            >
              <v-text-field
                required
                outlined
                type="number"
                :rules="[
                  required(`un valeur de pré-écrêté valide`),
                  rules.Length,
                  rules.pourcentageEcrete,
                ]"
                v-model="autreFournisseur.preEcrete"
                label="Valeur pré-écrêté"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2">
              <v-text-field
                type="number"
                step="1"
                required
                outlined
                suffix="mois"
                v-model="autreFournisseur.DUREE"
                label="Durée de contrat"
                :rules="[
                  rules.required(`une durée de contrat valide`),
                  rules.isPositiveNumb,
                ]"
              ></v-text-field>
            </v-col>

            <v-col class="pt-0 pl-0" cols="12">
              <v-switch
                v-model="autreFournisseur.multiYear"
                label="Offre multi-années (prix par année)"
                :color="$colors[0]"
                hide-details
                dense
                inset
                @change="toggleMultiYear"
              ></v-switch>
            </v-col>

            <!---------------------------------------------------------------------------------------------------------->

            <v-col
              class="pt-0 pl-0"
              cols="12"
              v-if="
                editFournisseur &&
                autreFournisseur.fournisseur == 'JPME' &&
                autreFournisseur.parametreCompteur == 'C4'
              "
            >
              <v-switch
                v-model="jpmeFileOuiNon"
                :label="`Récupérer les données JPME à partir d'un PDF :`"
                color="secondary"
                hide-details
                dense
                inset
              ></v-switch>
              <div
                class="mt-5"
                v-if="
                  autreFournisseur.fournisseur == 'JPME' &&
                  autreFournisseur.parametreCompteur == 'C4' &&
                  jpmeFileOuiNon == true
                "
              >
                <v-row cols="12">
                  <v-col cols="12">
                    <v-form ref="formJPMEFileUpload">
                      <v-text-field
                        v-model="margeJpme"
                        type="number"
                        label="Marge"
                        step="0.001"
                        min="0"
                        dense
                        outlined
                        style="max-width: 200px"
                        :rules="[required('une marge'), rules.margeMaxMinJpme]"
                      ></v-text-field>
                      <div>
                        <div
                          v-if="filePdfJpme"
                          style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                            gap: 15px;
                            width: 100%;
                            background-color: #edf1f3;
                            border: 1px solid #d8d8d8;
                            border-radius: 4px;
                            padding: 15px 15px;
                          "
                        >
                          <p class="mb-0">{{ filePdfJpme.name }}</p>
                          <v-icon @click="annulerDonnerJpme">mdi-close</v-icon>
                        </div>
                        <FileUpload v-else @files-uploaded="handleFileUpload" />
                      </div>
                      <div class="d-flex flex-row mt-4 mb-4" style="gap: 10px">
                        <button
                          @click.prevent="annulerDonnerJpme"
                          style="
                            font-size: 14px;
                            font-weight: 600;
                            border: 1px solid #9e9e9e;
                            color: #000000;
                            border-radius: 4px;
                            padding: 8px 24px;
                            height: 40px;
                          "
                        >
                          Annuler
                        </button>
                        <button
                          @click.prevent="getDonnerJpme"
                          style="
                            font-size: 14px;
                            background-color: #2562eb;
                            color: #fff;
                            border-radius: 4px;

                            padding: 8px 24px;
                            height: 40px;
                          "
                        >
                          Récupérer les données JPME
                        </button>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
                <div v-if="resultatJpmeApi.result == true">
                  <div class="jpme-prices-wrapper">
                    <div
                      v-for="(item, index) in resultatJpmeApi.data"
                      :key="index"
                      class="jpme-price-card"
                    >
                      <div class="jpme-price-item">
                        <v-select
                          v-model="item.typeOffre"
                          :items="['Fixe', 'Arenh']"
                          label="Type Offre"
                          hide-details="auto"
                          dense
                          filled
                          :rules="[required(`un type d'offre valide`), rules.Length]"
                        />
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.DUREE"
                          filled
                          hide-details="auto"
                          dense
                          label="DUREE"
                          :rules="[required('une DUREE valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.prixHPH"
                          filled
                          hide-details="auto"
                          dense
                          label="HPH"
                          :rules="[required('une Prix (HPH) valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.prixHCH"
                          filled
                          hide-details="auto"
                          dense
                          label="HCH"
                          :rules="[required('une Prix (HCH) valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.prixHPE"
                          filled
                          hide-details="auto"
                          dense
                          label="HPE"
                          :rules="[required('une Prix (HPE) valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.prixHCE"
                          filled
                          hide-details="auto"
                          dense
                          label="HCE"
                          :rules="[required('une Prix (HCE) valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-text-field
                          v-model="item.CEE"
                          filled
                          hide-details="auto"
                          dense
                          label="CEE"
                          :rules="[required('une (CEE) valide')]"
                        ></v-text-field>
                      </div>
                      <div class="jpme-price-item">
                        <v-select
                          v-model="item.typeCapa"
                          :items="['COEF', 'CAPA', 'CAPAINCLUS']"
                          label="Type Capa"
                          hide-details="auto"
                          dense
                          filled
                          :rules="[required(`un type capa`), rules.Length]"
                        />
                      </div>
                      <template v-if="item.typeCapa != 'CAPAINCLUS'">
                        <div class="jpme-price-item">
                          <v-text-field
                            v-model="item.capaHPH"
                            filled
                            hide-details="auto"
                            dense
                            label="Capa HPH"
                            :rules="[required('une Capa (HPH) valide')]"
                          ></v-text-field>
                        </div>
                        <div class="jpme-price-item">
                          <v-text-field
                            v-model="item.capaHCH"
                            filled
                            hide-details="auto"
                            dense
                            label="Capa HCH"
                            :rules="[required('une Capa (HCH) valide')]"
                          ></v-text-field>
                        </div>
                        <div class="jpme-price-item">
                          <v-text-field
                            v-model="item.capaHPE"
                            filled
                            hide-details="auto"
                            dense
                            label="Capa HPE"
                            :rules="[required('une Capa (HPE) valide')]"
                          ></v-text-field>
                        </div>
                        <div class="jpme-price-item">
                          <v-text-field
                            v-model="item.capaHCE"
                            filled
                            hide-details="auto"
                            dense
                            label="Capa HCE"
                            :rules="[required('une Capa (HCE) valide')]"
                          ></v-text-field>
                        </div>
                        <div class="jpme-price-item">
                          <v-text-field
                            v-model="item.ABO"
                            filled
                            hide-details="auto"
                            dense
                            label="ABO"
                            :rules="[required('une (ABO) valide')]"
                          ></v-text-field>
                        </div>
                      </template>
                    </div>
                  </div>

                  <!--  
                    <v-simple-table>
                      <tbody>
                        <tr v-for="(item, index) in resultatJpmeApi.data" :key="index">
                          <v-simple-table>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.typeOffre"
                                    outlined
                                    dense
                                    label="Type Offre"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.DUREE"
                                    outlined
                                    dense
                                    label="DUREE"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.prixHPH"
                                    outlined
                                    dense
                                    label="HPH"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.prixHCH"
                                    outlined
                                    dense
                                    label="HCH"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.prixHPE"
                                    outlined
                                    dense
                                    label="HPE"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.prixHCE"
                                    outlined
                                    dense
                                    label="HCE"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.CEE"
                                    outlined
                                    dense
                                    label="CEE"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.typeCapa"
                                    outlined
                                    dense
                                    label="Type Capa"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.capaHPH"
                                    outlined
                                    dense
                                    label="Capa HPH"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.capaHCH"
                                    outlined
                                    dense
                                    label="Capa HCH"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.capaHPE"
                                    outlined
                                    dense
                                    label="Capa HPE"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.capaHCE"
                                    outlined
                                    dense
                                    label="Capa HCE"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-text-field style="margin-top: 10px;"
                                    v-model="item.ABO"
                                    outlined
                                    dense
                                    label="ABO"
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-btn @click="Ajouter">
                                    +
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    -->
                </div>
                <!-- <div v-else class="alert alert-warning" role="alert">
                    Erreur api le document on ne peut pas le traiter
                  </div>-->
              </div>
            </v-col>
          </v-row>

          <!-- EDIT MODE: existing prix + capa sections -->
          <template v-if="editFournisseur">
          <!-- Prix -->
          <v-row
            class="ma-0 pa-0"
            v-if="
              !autreFournisseur.multiYear &&
              ((autreFournisseur.fournisseur == 'JPME' &&
                autreFournisseur.parametreCompteur == 'C4' &&
                jpmeFileOuiNon == false) ||
              autreFournisseur.fournisseur != 'JPME' ||
              autreFournisseur.parametreCompteur != 'C4')
            "
          >
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-1 pa-0">
              <v-subheader class="ma-0">Prix du MWh :</v-subheader>
              <v-divider class="ma-0 pa-0"></v-divider>
              <!-- add checkbox : -->
              <v-checkbox
                v-model="autreFournisseur.isEnergieVerte"
                label="Énergie Verte"
                class="ma-2"
                dense
                :hint="'Option pour choisir une électricité d\'origine renouvelable'"
                @change="val => !val && (autreFournisseur.prixEnergieVerte = 0)"
                persistent-hint
              ></v-checkbox>
               
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="autreFournisseur.parametreCompteur == 'C3'"
            >
              <v-text-field
                type="number"
                step="0.001"
                required
                outlined
                v-model="autreFournisseur.prixPOINTE"
                suffix="€"
                label="(P)"
                :rules="[required('un PRIX (P) valide')]"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="!!autreFournisseur.numCompteur"
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
            >
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5BASE'"
                type="number"
                step="0.001"
                required
                outlined
                v-model="autreFournisseur.prixBASE"
                label="(BASE)"
                :rules="[required('une valeur valide')]"
              ></v-text-field>
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHPH"
                label="(HPH)"
                :rules="[required('un PRIX (HPH) valide')]"
              ></v-text-field>
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5HP'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHP"
                label="(HP)"
                :rules="[required('un PRIX (HP) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                autreFournisseur.parametreCompteur == 'C3' ||
                autreFournisseur.parametreCompteur == 'C5HP' ||
                autreFournisseur.parametreCompteur == 'C4' ||
                autreFournisseur.parametreCompteur == 'C5C4'
              "
            >
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHCH"
                label="(HCH)"
                :rules="[required('un PRIX (HCH) valide')]"
              ></v-text-field>
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5HP'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHC"
                label="(HC)"
                :rules="[required('un PRIX (HC) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                autreFournisseur.parametreCompteur == 'C3' ||
                autreFournisseur.parametreCompteur == 'C4' ||
                autreFournisseur.parametreCompteur == 'C5C4'
              "
            >
              <v-text-field
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHPE"
                label="(HPE)"
                :rules="[required('un PRIX (HPE) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                autreFournisseur.parametreCompteur == 'C3' ||
                autreFournisseur.parametreCompteur == 'C4' ||
                autreFournisseur.parametreCompteur == 'C5C4'
              "
            >
              <v-text-field
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.prixHCE"
                label="(HCE)"
                :rules="[required('un PRIX (HCE) valide')]"
              ></v-text-field>
            </v-col>

            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2">
              <v-text-field
                type="number"
                step="0.001"
                required
                outlined
                suffix="€"
                v-model="autreFournisseur.CEE"
                label="CEE"
                :rules="[required('un CEE valide')]"
              ></v-text-field>
            </v-col>
            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2" v-if="autreFournisseur.isEnergieVerte">
              <v-text-field
                type="number"
               
                step="0.001"
                required
                outlined
                suffix="€"
                v-model="autreFournisseur.prixEnergieVerte"
                label="Prix energie verte"
                :rules="[required('une valeur valide')]"
              ></v-text-field>
            </v-col>
            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2">
              <v-text-field
                type="number"
                step="0.001"
                required
                outlined
                suffix="€"
                v-model="autreFournisseur.ABO"
                label="Abonnement mensuel"
                :rules="[required('une valeur valide')]"
              ></v-text-field>
            </v-col>
            
          </v-row>

          <!-- coef capa -->
          <v-row
            class="ma-0 pa-0"
            v-if="
              (autreFournisseur.fournisseur == 'JPME' &&
                autreFournisseur.parametreCompteur == 'C4' &&
                jpmeFileOuiNon == false) ||
              autreFournisseur.fournisseur != 'JPME' ||
              autreFournisseur.parametreCompteur != 'C4'
            "
          >
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-1 pa-0">
              <v-subheader class="ma-0">Informations sur la capacité :</v-subheader>
              <v-divider class="ma-0 pa-0"></v-divider>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="ma-1 pa-0">
              <v-radio-group v-model="autreFournisseur.typeCapa" row class="ma-0 pa-0">
                <v-radio
                  :color="$colors[2]"
                  label="Coût capacité €/MWh"
                  value="CAPA"
                ></v-radio>
                <v-radio
                  :color="$colors[2]"
                  label="Coefficient capacité €/MWh"
                  value="COEF"
                ></v-radio>
                <v-radio
                  :color="$colors[2]"
                  label="CAPA Inclus"
                  value="CAPAINCLUS"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                !autreFournisseur.multiYear && autreFournisseur.typeCapa != 'CAPAINCLUS' &&
                autreFournisseur.parametreCompteur == 'C3'
              "
            >
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C3'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaPOINTE"
                label="(P)"
                :rules="[required('un CAPA (P) valide')]"
              ></v-text-field>
            </v-col>
            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="!autreFournisseur.multiYear && autreFournisseur.typeCapa != 'CAPAINCLUS'"
            >
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5BASE'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaBASE"
                label="(BASE)"
                :rules="[required('une valeur valide')]"
              ></v-text-field>
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHPH"
                label="(HPH)"
                :rules="[required('un CAPA (HPH) valide')]"
              ></v-text-field>
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5HP'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHP"
                label="(HP)"
                :rules="[required('un CAPA (HP) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                !autreFournisseur.multiYear && autreFournisseur.typeCapa != 'CAPAINCLUS' &&
                (autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4' ||
                  autreFournisseur.parametreCompteur == 'C5HP')
              "
            >
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHCH"
                label="(HCH)"
                :rules="[required('un CAPA (HCH) valide')]"
              ></v-text-field>
              <v-text-field
                v-if="autreFournisseur.parametreCompteur == 'C5HP'"
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHC"
                label="(HC)"
                :rules="[required('un CAPA (HC) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                !autreFournisseur.multiYear && autreFournisseur.typeCapa != 'CAPAINCLUS' &&
                (autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4')
              "
            >
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHPE"
                label="(HPE)"
                :rules="[required('un CAPA (HPE) valide')]"
              ></v-text-field>
            </v-col>

            <v-col
              class="pl-0"
              cols="11"
              sm="3"
              md="2"
              lg="2"
              xl="2"
              v-if="
                !autreFournisseur.multiYear && autreFournisseur.typeCapa != 'CAPAINCLUS' &&
                (autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4')
              "
            >
              <v-text-field
                v-if="
                  autreFournisseur.parametreCompteur == 'C3' ||
                  autreFournisseur.parametreCompteur == 'C4' ||
                  autreFournisseur.parametreCompteur == 'C5C4'
                "
                type="number"
                step="0.001"
                suffix="€"
                required
                outlined
                v-model="autreFournisseur.capaHCE"
                label="(HCE)"
                :rules="[required('un CAPA (HCE) valide')]"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- prix par année (multi-années, mode modification) -->
          <v-row
            v-if="autreFournisseur.multiYear && fieldsPerParametre[autreFournisseur.parametreCompteur]"
            class="ma-0 pa-0"
          >
            <v-col cols="12" class="ma-1 pa-0">
              <v-subheader class="ma-0">Prix par année (€/MWh) :</v-subheader>
              <v-divider class="ma-0 pa-0"></v-divider>
              <v-checkbox
                v-model="autreFournisseur.isEnergieVerte"
                label="Énergie Verte"
                class="ma-2"
                dense
                :hint="'Option pour choisir une électricité d\'origine renouvelable'"
                @change="val => !val && (autreFournisseur.prixEnergieVerte = 0)"
                persistent-hint
              ></v-checkbox>
            </v-col>
            <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2" v-if="autreFournisseur.isEnergieVerte">
              <v-text-field
                type="number"
                step="0.001"
                required
                outlined
                suffix="€"
                v-model="autreFournisseur.prixEnergieVerte"
                label="Prix energie verte"
                :rules="[required('une valeur valide')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pa-0" v-if="autreFournisseur.years.length > 0">
              <div class="table-prix-annees-wrapper">
                <table class="table-prix-annees">
                  <thead>
                    <tr>
                      <th rowspan="2"></th>
                      <th :colspan="fieldsPerParametre[autreFournisseur.parametreCompteur].prix.length">Prix (€/MWh)</th>
                      <th
                        v-if="autreFournisseur.typeCapa != 'CAPAINCLUS'"
                        :colspan="fieldsPerParametre[autreFournisseur.parametreCompteur].capa.length"
                      >
                        Capacité (€/MWh)
                      </th>
                      <th rowspan="2">CEE (€/MWh)</th>
                      <th rowspan="2">Abonnement mensuel (€)</th>
                    </tr>
                    <tr>
                      <th v-for="field in fieldsPerParametre[autreFournisseur.parametreCompteur].prix" :key="field">
                        {{ fieldLabels[field].replace(/[()]/g, '') }}
                      </th>
                      <template v-if="autreFournisseur.typeCapa != 'CAPAINCLUS'">
                        <th v-for="field in fieldsPerParametre[autreFournisseur.parametreCompteur].capa" :key="field">
                          {{ fieldLabels[field].replace(/[()]/g, '') }}
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(year, indexYear) in autreFournisseur.years" :key="indexYear">
                      <td class="annee">{{ year.annee }}</td>
                      <td v-for="field in fieldsPerParametre[autreFournisseur.parametreCompteur].prix" :key="field">
                        <v-text-field type="number" step="0.001" outlined dense hide-details
                          v-model="year[field]" :rules="[required('une valeur valide')]"></v-text-field>
                      </td>
                      <template v-if="autreFournisseur.typeCapa != 'CAPAINCLUS'">
                        <td v-for="field in fieldsPerParametre[autreFournisseur.parametreCompteur].capa" :key="field">
                          <v-text-field type="number" step="0.001" outlined dense hide-details
                            v-model="year[field]" :rules="[required('une valeur valide')]"></v-text-field>
                        </td>
                      </template>
                      <td>
                        <v-text-field type="number" step="0.001" outlined dense hide-details
                          v-model="year.CEE" :rules="[required('un CEE valide')]"></v-text-field>
                      </td>
                      <td>
                        <v-text-field type="number" step="0.001" outlined dense hide-details
                          v-model="year.ABO" :rules="[required('une valeur valide')]"></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
            <v-col cols="12" class="pa-0" v-else>
              <span class="grey--text">
                Saisissez la durée de contrat pour afficher les années de l'offre.
              </span>
            </v-col>
            <v-col cols="12" class="pa-0 mt-2" v-if="erreurMultiYear">
              <v-alert dense outlined type="error" class="ma-0">{{ erreurMultiYear }}</v-alert>
            </v-col>
          </v-row>
          </template>

          <!-- ADD MULTI-MODE: grouped cadrants by parametreCompteur -->
          <template v-if="!editFournisseur && dialogStep === 2">
            <div v-for="param in groupedParametreCompteurs" :key="param" class="mb-4">
              <v-row class="ma-0 pa-0" v-if="!autreFournisseur.multiYear">
                <v-col cols="12" class="ma-1 pa-0">
                  <v-subheader class="ma-0 font-weight-bold">{{ param }} — Prix du MWh :</v-subheader>
                  <v-divider class="ma-0 pa-0"></v-divider>
                </v-col>
                <v-col
                  class="pl-0"
                  cols="11"
                  sm="3"
                  md="2"
                  lg="2"
                  xl="2"
                  v-for="field in fieldsPerParametre[param].prix"
                  :key="field"
                >
                  <v-text-field
                    type="number"
                    step="0.001"
                    suffix="€"
                    required
                    outlined
                    v-model="prixParGroupe[param][field]"
                    :label="fieldLabels[field]"
                    :rules="[required('une valeur valide')]"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-1 pa-0">
                  <v-subheader class="ma-0 font-weight-bold">{{ param }} — Capacité :</v-subheader>
                  <v-divider class="ma-0 pa-0"></v-divider>
                </v-col>
                <v-col cols="12" class="ma-1 pa-0">
                  <v-radio-group v-model="prixParGroupe[param].typeCapa" row class="ma-0 pa-0">
                    <v-radio :color="$colors[2]" label="Coût capacité €/MWh" value="CAPA"></v-radio>
                    <v-radio :color="$colors[2]" label="Coefficient capacité €/MWh" value="COEF"></v-radio>
                    <v-radio :color="$colors[2]" label="CAPA Inclus" value="CAPAINCLUS"></v-radio>
                  </v-radio-group>
                </v-col>
                <template v-if="!autreFournisseur.multiYear && prixParGroupe[param].typeCapa !== 'CAPAINCLUS'">
                  <v-col
                    class="pl-0"
                    cols="11"
                    sm="3"
                    md="2"
                    lg="2"
                    xl="2"
                    v-for="field in fieldsPerParametre[param].capa"
                    :key="field"
                  >
                    <v-text-field
                      type="number"
                      step="0.001"
                      suffix="€"
                      required
                      outlined
                      v-model="prixParGroupe[param][field]"
                      :label="fieldLabels[field]"
                      :rules="[required('une valeur valide')]"
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>

              <!-- prix par année du groupe (multi-années) -->
              <v-row class="ma-0 pa-0" v-if="autreFournisseur.multiYear">
                <v-col cols="12" class="ma-1 pa-0">
                  <v-subheader class="ma-0 font-weight-bold">{{ param }} — Prix par année (€/MWh) :</v-subheader>
                  <v-divider class="ma-0 pa-0"></v-divider>
                </v-col>
                <v-col cols="12" class="pa-0" v-if="(prixParGroupe[param].years || []).length > 0">
                  <div class="table-prix-annees-wrapper">
                    <table class="table-prix-annees">
                      <thead>
                        <tr>
                          <th rowspan="2"></th>
                          <th :colspan="fieldsPerParametre[param].prix.length">Prix (€/MWh)</th>
                          <th v-if="prixParGroupe[param].typeCapa != 'CAPAINCLUS'" :colspan="fieldsPerParametre[param].capa.length">
                            Capacité (€/MWh)
                          </th>
                          <th rowspan="2">CEE (€/MWh)</th>
                          <th rowspan="2">Abonnement mensuel (€)</th>
                        </tr>
                        <tr>
                          <th v-for="field in fieldsPerParametre[param].prix" :key="field">
                            {{ fieldLabels[field].replace(/[()]/g, '') }}
                          </th>
                          <template v-if="prixParGroupe[param].typeCapa != 'CAPAINCLUS'">
                            <th v-for="field in fieldsPerParametre[param].capa" :key="field">
                              {{ fieldLabels[field].replace(/[()]/g, '') }}
                            </th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(year, indexYear) in prixParGroupe[param].years" :key="indexYear">
                          <td class="annee">{{ year.annee }}</td>
                          <td v-for="field in fieldsPerParametre[param].prix" :key="field">
                            <v-text-field type="number" step="0.001" outlined dense hide-details
                              v-model="year[field]" :rules="[required('une valeur valide')]"></v-text-field>
                          </td>
                          <template v-if="prixParGroupe[param].typeCapa != 'CAPAINCLUS'">
                            <td v-for="field in fieldsPerParametre[param].capa" :key="field">
                              <v-text-field type="number" step="0.001" outlined dense hide-details
                                v-model="year[field]" :rules="[required('une valeur valide')]"></v-text-field>
                            </td>
                          </template>
                          <td>
                            <v-text-field type="number" step="0.001" outlined dense hide-details
                              v-model="year.CEE" :rules="[required('un CEE valide')]"></v-text-field>
                          </td>
                          <td>
                            <v-text-field type="number" step="0.001" outlined dense hide-details
                              v-model="year.ABO" :rules="[required('une valeur valide')]"></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-col>
                <v-col cols="12" class="pa-0" v-else>
                  <span class="grey--text">
                    Saisissez la durée de contrat pour afficher les années de l'offre.
                  </span>
                </v-col>
              </v-row>
            </div>
            <v-row class="ma-0 pa-0" v-if="autreFournisseur.multiYear && erreurMultiYear">
              <v-col cols="12" class="pa-0 mt-2">
                <v-alert dense outlined type="error" class="ma-0">{{ erreurMultiYear }}</v-alert>
              </v-col>
            </v-row>

            <!-- Shared fields: CEE, ABO, Energie Verte -->
            <v-row class="ma-0 pa-0" v-if="groupedParametreCompteurs.length > 0">
              <v-col cols="12" class="ma-1 pa-0">
                <v-subheader class="ma-0">Informations communes :</v-subheader>
                <v-divider class="ma-0 pa-0"></v-divider>
                <v-checkbox
                  v-model="autreFournisseur.isEnergieVerte"
                  label="Énergie Verte"
                  class="ma-2"
                  dense
                  :hint="'Option pour choisir une électricité d\'origine renouvelable'"
                  @change="val => !val && (autreFournisseur.prixEnergieVerte = 0)"
                  persistent-hint
                ></v-checkbox>
              </v-col>
              <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2" v-if="!autreFournisseur.multiYear">
                <v-text-field
                  type="number"
                  step="0.001"
                  required
                  outlined
                  suffix="€"
                  v-model="autreFournisseur.CEE"
                  label="CEE"
                  :rules="[required('un CEE valide')]"
                ></v-text-field>
              </v-col>
              <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2" v-if="!autreFournisseur.multiYear">
                <v-text-field
                  type="number"
                  step="0.001"
                  required
                  outlined
                  suffix="€"
                  v-model="autreFournisseur.ABO"
                  label="Abonnement mensuel"
                  :rules="[required('une valeur valide')]"
                ></v-text-field>
              </v-col>
              <v-col class="pl-0" cols="11" sm="3" md="2" lg="2" xl="2" v-if="autreFournisseur.isEnergieVerte">
                <v-text-field
                  type="number"
                  step="0.001"
                  required
                  outlined
                  suffix="€"
                  v-model="autreFournisseur.prixEnergieVerte"
                  label="Prix energie verte"
                  :rules="[required('une valeur valide')]"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Retour button -->
            <v-row class="ma-0 pa-0">
              <v-col cols="auto">
                <v-btn text @click="dialogStep = 1">
                  Retour
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-form>
        <v-card-actions>
          <v-row class="ma-2" justify="space-between">
            <div>
              <v-btn
                v-if="editFournisseur == false"
                @click="resetFournisseurActuelle"
                color="error"
                text
              >
                Supprimer et Fermer
              </v-btn>
            </div>
            <div>
              <v-btn
                color="error"
                class="marginBtn ml-5"
                text
                @click="closeModalHandleFournisseur"
              >
                Fermer
              </v-btn>
              <v-btn
                :color="$colors[0]"
                class="marginBtn ml-5 text-white"
                v-if="editFournisseur == true"
                @click="AjouterFournisseur(indexFournisseurEdited)"
              >
                Modifier
              </v-btn>
              <v-btn
                :color="$colors[0]"
                class="marginBtn ml-5 text-white"
                v-if="editFournisseur == false"
                @click="
                  () =>
                    jpmeFileOuiNon ? AjouterFournisseurJpmePdf() : AjouterFournisseur(-1)
                "
              >
                Ajouter
              </v-btn>
            </div>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- les deux bottion pricipale -->
    <v-row class="mb-12" v-if="enedisRecherche">
      <!-- affichage des donner du fornisseur actuelle -->
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        class="ma-0 pa-0"
        v-if="tousLesAutreFournisseur.length > 0"
      >
        <v-subheader class="ml-3">Informations des autres Fournisseurs :</v-subheader>
        <v-divider class="mx-4 pa-0"></v-divider>
      </v-col>
      <v-expansion-panels class="ma-3" v-if="tousLesAutreFournisseur.length > 0">
        <v-expansion-panel v-for="(item, index) in tousLesAutreFournisseur" :key="index">
          <v-expansion-panel-header hide-actions class="responsiveClass">
            <v-btn
              max-width="50"
              icon
              plain
              color="error"
              @click.stop="supprimerFournisseur(index)"
            >
              <v-icon center>mdi-delete </v-icon>
            </v-btn>
            <v-btn
              max-width="50"
              class="reponsiveBtn"
              icon
              plain
              @click.stop="editFournisseurMethod(index)"
            >
              <v-icon :color="$colors[0]">mdi-pencil </v-icon>
            </v-btn>
            <v-subheader
              class="ma-0 d-flex flex-row justify-space-between"
              v-if="item.typeFournisseur == 'Actuelle'"
            >
              <div>
                Informations du fournisseur actuel :
                <b class="pl-2">{{ item.fournisseur === 'TDE' ? 'Total Energies' : item.fournisseur }}</b>
              </div>
              
              <div style="gap: 10px" class="d-flex flex-column">
                <span style="font-size: 0.92rem">Compteur : {{ item.numCompteur }}</span>
                <span v-if="item.dateSaisie" style="font-size: 0.92rem"
                  >Date de saisie de l'offre : {{ item.dateSaisie }}</span
                >
              </div>
            </v-subheader>

            <v-subheader class="ma-0 d-flex flex-row justify-space-between" v-else>
              <div>
                Informations du nouveau fournisseur :
                <b class="pl-2">{{ item.fournisseur === 'TDE' ? 'Total Energies' : item.fournisseur }}</b>
              </div>
              <div style="gap: 10px" class="d-flex flex-column">
                <span style="font-size: 0.92rem">Compteur : {{ item.numCompteur }}</span>
                <span v-if="item.dateSaisie" style="font-size: 0.92rem"
                  >Date de saisie de l'offre : {{ item.dateSaisie }}</span
                >
              </div>
            </v-subheader>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            style="background-color: rgb(245, 245, 245)"
            class="pa-4"
          >
            <v-row justify="space-between">
              <v-col class="pa-0">
                <h5 class="mb-8">Informations Générales</h5>
                <v-row class="mx-4">
                  <span class="grey--text mb-0">Fournisseur : </span
                  ><span class="ml-2" style="color: #1a1a1a; font-weight: bold">{{
                    item.fournisseur === 'TDE' ? 'Total Energies' : item.fournisseur
                  }}</span>
                </v-row>
                <v-row class="mx-4">
                  <span class="grey--text mb-0">TURPE INCLUS : </span
                  ><span class="ml-2" style="color: #1a1a1a; font-weight: bold">{{
                    item.turpeInclus
                  }}</span>
                </v-row>
                <v-row class="mx-4">
                  <span class="grey--text mb-0">Ajout Marge : </span
                  ><span class="ml-2" style="color: #1a1a1a; font-weight: bold">{{
                    item.ajoutMarge ? "oui" : "non"
                  }}</span>
                </v-row>
                <v-row class="mx-4">
                  <span class="grey--text mb-0">Durée de contrat : </span
                  ><span class="ml-2" style="color: #1a1a1a; font-weight: bold"
                    >{{ item.DUREE }} mois</span
                  >
                </v-row>
              </v-col>
              <v-col class="pa-0" v-if="item.multiYear && fieldsPerParametre[item.parametreCompteur]" cols="12" md="8">
                <h5 class="mb-8">Prix par année</h5>
                <div class="table-prix-annees-wrapper">
                  <table class="table-prix-annees lecture">
                    <thead>
                      <tr>
                        <th rowspan="2"></th>
                        <th :colspan="fieldsPerParametre[item.parametreCompteur].prix.length">Prix (€/MWh)</th>
                        <th v-if="item.typeCapa != 'CAPAINCLUS'" :colspan="fieldsPerParametre[item.parametreCompteur].capa.length">
                          Capacité (€/MWh)
                        </th>
                        <th rowspan="2">CEE (€/MWh)</th>
                        <th rowspan="2">Abonnement mensuel (€)</th>
                      </tr>
                      <tr>
                        <th v-for="field in fieldsPerParametre[item.parametreCompteur].prix" :key="field">
                          {{ fieldLabels[field].replace(/[()]/g, '') }}
                        </th>
                        <template v-if="item.typeCapa != 'CAPAINCLUS'">
                          <th v-for="field in fieldsPerParametre[item.parametreCompteur].capa" :key="field">
                            {{ fieldLabels[field].replace(/[()]/g, '') }}
                          </th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(year, indexYear) in item.years" :key="indexYear">
                        <td class="annee">{{ year.annee }}</td>
                        <td v-for="field in fieldsPerParametre[item.parametreCompteur].prix" :key="field">{{ year[field] }}</td>
                        <template v-if="item.typeCapa != 'CAPAINCLUS'">
                          <td v-for="field in fieldsPerParametre[item.parametreCompteur].capa" :key="field">{{ year[field] }}</td>
                        </template>
                        <td>{{ year.CEE }}</td>
                        <td>{{ year.ABO }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="mt-4" v-if="item.isEnergieVerte">
                  <span class="grey--text">Prix énergie verte : </span>
                  <span style="color: #1a1a1a; font-weight: bold">{{ item.prixEnergieVerte }}€</span>
                </p>
              </v-col>
              <v-col class="pa-0" v-if="!item.multiYear">
                <h5 class="mb-8">Coût du MWh</h5>
                <v-row class="pa-0" v-if="item.parametreCompteur == 'C5BASE'">
                  <p class="mx-4">
                    <span class="grey--text mb-2">BASE : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixBASE }}€</span
                    >
                  </p>
                </v-row>
                <v-row class="pa-0" v-if="item.parametreCompteur == 'C5HP'">
                  <p class="mx-4">
                    <span class="grey--text mb-2">HP : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHP }}€</span
                    >
                  </p>
                  <p class="mx-4">
                    <span class="grey--text mb-2">HC : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHC }}€</span
                    >
                  </p>
                </v-row>

                <v-row
                  class="pa-0"
                  v-if="
                    item.parametreCompteur == 'C3' ||
                    item.parametreCompteur == 'C4' ||
                    item.parametreCompteur == 'C5C4'
                  "
                >
                <p class="mx-4">
                    <span class="grey--text mb-2">HPH : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHPH }}€</span
                    >
                  </p>
                  <p class="mx-4">
                    <span class="grey--text mb-2">HCH : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHCH }}€</span
                    >
                  </p>
                 
                </v-row>

                <v-row class="pa-0" v-if="item.parametreCompteur == 'C3'">
                  <p class="mx-4">
                    <span class="grey--text mb-2">POINTE : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixPOINTE }}€</span
                    >
                  </p>
                </v-row>

                <v-row
                  class="pa-0"
                  v-if="
                    item.parametreCompteur == 'C3' ||
                    item.parametreCompteur == 'C4' ||
                    item.parametreCompteur == 'C5C4'
                  "
                >
                <p class="mx-4">
                    <span class="grey--text mb-2">HPE : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHPE }}€</span
                    >
                  </p>
                  <p class="mx-4">
                    <span class="grey--text mb-2">HCE : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixHCE }}€</span
                    >
                  </p>
                 
                </v-row>

                <v-row class="pa-0">
                  <p class="mx-4">
                    <span class="grey--text mb-2">CEE : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.CEE }}€</span
                    >
                  </p>
                  <p class="mx-4">
                    <span class="grey--text mb-2">ABO Mensuel : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.ABO }}€</span
                    >
                  </p>
                  
                </v-row>
                <v-row class="pa-0" v-if="item.isEnergieVerte">
                  <p class="mx-4">
                    <span class="grey--text mb-2">Prix Energie Verte : </span
                    ><span style="color: #1a1a1a; font-weight: bold"
                      >{{ item.prixEnergieVerte }}€</span
                    >
                  </p>
                 
                  
                </v-row>
              </v-col>

              <v-col class="pa-0" v-if="!item.multiYear">
                <h5 class="mb-8">Informations sur la Capacité</h5>
                <v-row v-if="item.typeCapa != 'CAPAINCLUS'">
                  <div class="mb-0" v-if="item.parametreCompteur == 'C5BASE'">
                    <p class="mx-4">
                      <span class="grey--text mb-2">BASE : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaBASE }}€</span
                      >
                    </p>
                  </div>
                  <div class="mb-0" v-if="item.parametreCompteur == 'C5HP'">
                    <p class="mx-4">
                      <span class="grey--text mb-2">HP : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHP }}€</span
                      >
                    </p>
                  </div>
                  <div class="mb-0" v-if="item.parametreCompteur == 'C5HP'">
                    <p class="mx-4">
                      <span class="grey--text mb-2">HC : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHC }}€</span
                      >
                    </p>
                  </div>
                  <div
                    class="mb-0"
                    v-if="
                      item.parametreCompteur == 'C3' ||
                      item.parametreCompteur == 'C4' ||
                      item.parametreCompteur == 'C5C4'
                    "
                  >
                    <p class="mx-4">
                      <span class="grey--text mb-2">HPH : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHPH }}€</span
                      >
                    </p>
                  </div>
                  <div
                    class="mb-0"
                    v-if="
                      item.parametreCompteur == 'C3' ||
                      item.parametreCompteur == 'C4' ||
                      item.parametreCompteur == 'C5C4'
                    "
                  >
                    <p class="mx-4">
                      <span class="grey--text mb-2">HCH : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHCH }}€</span
                      >
                    </p>
                  </div>
                </v-row>
                <v-row
                  v-if="
                    item.typeCapa != 'CAPAINCLUS' &&
                    (item.parametreCompteur == 'C3' ||
                      item.parametreCompteur == 'C4' ||
                      item.parametreCompteur == 'C5C4')
                  "
                >
                  <div>
                    <p class="mx-4">
                      <span class="grey--text mb-2">HPE : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHPE }}€</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="mx-4">
                      <span class="grey--text mb-2">HCE : </span
                      ><span style="color: #1a1a1a; font-weight: bold"
                        >{{ item.capaHCE }}€</span
                      >
                    </p>
                  </div>
                </v-row>
                <v-row
                  v-if="item.typeCapa != 'CAPAINCLUS' && item.parametreCompteur == 'C3'"
                >
                  <div>
                    <p class="mx-4">
                      <span class="grey--text mb-2">POINTE : </span>{{ item.capaPOINTE }}€
                    </p>
                  </div>
                </v-row>
                <v-row>
                  <p class="mx-4">
                    <span class="grey--text">Type des valeurs de CAPA : </span>
                    <span
                      style="color: #1a1a1a; font-weight: bold"
                      v-if="item.typeCapa == 'CAPA'"
                      >Coût</span
                    >
                    <span
                      style="color: #1a1a1a; font-weight: bold"
                      v-if="item.typeCapa == 'COEF'"
                      >Coefficient</span
                    >
                    <span
                      style="color: #1a1a1a; font-weight: bold"
                      v-if="item.typeCapa == 'CAPAINCLUS'"
                      >CAPA Inclus</span
                    >
                  </p>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="d-flex flex-row mt-4" v-if="enedisRecherche">
        <v-btn @click="resetForm" depressed large class="mx-2" elevation="1" width="75%">
          Réinitialiser
        </v-btn>
        <v-btn
          depressed
          elevation="1"
          large
          @click="calculer"
          class="mx-2 text-white"
          :color="$colors[0]"
          width="70%"
        >
          Calculer
        </v-btn>
      </div>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";

import loadingComponent from "../../ui/loading-component.vue";
import FileUpload from "./components/FileUpload.vue";
export default {
  name: "FourmulaireDeCotation",
  components: { loadingComponent, FileUpload },
  props: {
    isHistorique: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      margeJpme: 0,
      jpmeFileOuiNon: false,
      filePdfJpme: null,
      resultatJpmeApi: {
        result: false,
      },
      toutLesDonneesEnedis: {},
      dataEnedisComplexParCompteur: {},
      dataAutreFournisseurComplexParCompteur: {},
      raison:"",
      todayDate: this.formatDate(new Date()),
      listHeaders: [
        "Compteur",
        "Options Tarifaire",
        "Puissance Souscrite",
        "HPH/HP/BASE",
        "HCH/HC",
        "HPE",
        "HCE",
        "POINTE",
        "Consommation Globale",
        "Mois/Enedis",
        "Date Début",
        "Date Fin",
      ],
      id_historique_cotation: "",
      marge: "",
      margeAbo:"0",
      dateDebut: "",
      dateFin: "",
      optionTarifaire: "",
      listBodyArray: [],
      listCompteurSelected: [],
      compteurPDL: 0,
      editFournisseur: false,
      indexFournisseurEdited: -1,
      errorDateDeFin: false,
      nbrMonth: 0,
      dialog: false,
      loading: false,
      error: false,
      messageDialogeSucces: "",
      messageDialogeError: "",
      errorEnedis: false,
      openModalFornisseurActuelle: false,
      vraiSiret: false,
      resultatEnedisMesure: false,
      resultatEnedisTechnique: false,
      enedisRecherche: false,
      siret: "",
      valueRechercheSiret: "",
      listSociete: [{ data: "", disable: true }],
      listCompteur: [],
      parametreCompteur: "",
      scoreEllipro: "",
      scoreCreditSafe: "",
      listProposition: [],
      optionsTarifaires: [
        "BTINFCU4",
        "BTINFCUST",
        "BTINFMU4",
        "BTINFMUDT",
        "BTINFLU",
        "BTSUPCU4",
        "BTSUPLU4",
        "HTACU5",
        "HTACUPM5",
        "HTALU5",
        "HTALUPM5",
      ],

      listDonnerCotation: [],

      tousLesAutreFournisseur: [],
      defaulttousLesAutreFournisseur: [],
      autreFournisseur: {
        parametreCompteur: "",
        typeFournisseur: "Fournisseur",
        isEnergieVerte: false,
        Classique: ["Classique"],
        preEcrete: "0",
        turpeInclus: "non",
        ajoutMarge: false,
        fournisseur: null,
        typeOffre: "",
        prixHPH: null,
        prixHCH: null,
        prixHPE: null,
        prixHCE: null,
        prixHP: null,
        prixHC: null,
        prixBASE: null,
        prixPOINTE: null,
        typeCapa: "CAPA",
        capaHPH: null,
        capaHCH: null,
        capaHPE: null,
        capaHCE: null,
        capaHP: null,
        capaHC: null,
        capaBASE: null,
        capaPOINTE: null,
        CEE: null,
        ABO: null,
        prixEnergieVerte:null,

        DUREE: null,
        multiYear: false,
        years: [],
      },
      defaultAutreFournisseur: {
        parametreCompteur: "",
        typeFournisseur: "Fournisseur",
        Classique: ["Classique"],
        preEcrete: "0",
        turpeInclus: "non",
        ajoutMarge: false,
        fournisseur: null,
        typeOffre: "",
        prixHPH: null,
        prixHCH: null,
        prixHPE: null,
        prixHCE: null,
        prixHP: null,
        prixHC: null,
        prixBASE: null,
        prixPOINTE: null,
        typeCapa: "CAPA",
        capaHPH: null,
        capaHCH: null,
        capaHPE: null,
        capaHCE: null,
        capaHP: null,
        capaHC: null,
        capaBASE: null,
        capaPOINTE: null,
        CEE: null,
        ABO: null,
        prixEnergieVerte:null,
        isEnergieVerte: false,
        DUREE: null,
        multiYear: false,
        years: [],
      },
      selectedCompteursMulti: [],
      dialogStep: 1,
      prixParGroupe: {},
      erreurMultiYear: "",
      cacheAnneesAutreFournisseur: {},
      listCompteurSelectedComputedFournisseurActuelle: [],
      fournisseurActuelle: false,
      optionsFournisseurs: [
  {'key': 'Alpiq', 'code_unique': 'F-AEF', 'nom_fournisseur': 'Alpiq Energie France'},
  {'key': 'ALSEN', 'code_unique': 'F-ALS', 'nom_fournisseur': 'ALSEN'},
  {'key': 'Alterna', 'code_unique': 'F-ALT', 'nom_fournisseur': 'Alterna énergie'},
  {'key': 'Axpo', 'code_unique': 'F-AXP', 'nom_fournisseur': 'Axpo'},
  {'key': 'China_Power', 'code_unique': 'F-CHP', 'nom_fournisseur': 'China Power'},
  {'key': 'Dyneff', 'code_unique': 'F-DY2', 'nom_fournisseur': 'Dyneff'},
  {'key': 'Edenkia', 'code_unique': 'F-EDK', 'nom_fournisseur': 'Edenkia'},
  {'key': 'EDF', 'code_unique': 'F-EDF', 'nom_fournisseur': 'EDF Entreprises'},
  {'key': 'EDSB', 'code_unique': 'F-EDS', 'nom_fournisseur': 'EDSB l\'agence'},
  {'key': 'Ekwateur', 'code_unique': 'F-EKW', 'nom_fournisseur': 'Ekwateur'},
  {'key': 'Elecocite', 'code_unique': 'F-ELC', 'nom_fournisseur': 'élecocité'},
  {'key': 'Electricite_de_provence', 'code_unique': 'F-EDP', 'nom_fournisseur': 'Electricité de Provence'},
  {'key': 'Electricite_de_savoie', 'code_unique': 'F-ELS', 'nom_fournisseur': 'Électricité de Savoie'},
  {'key': 'ELMY', 'code_unique': 'F-ELM', 'nom_fournisseur': 'elmy'},
  {'key': 'Enalp', 'code_unique': 'F-ENL', 'nom_fournisseur': 'ENALP'},
  {'key': 'Endesa', 'code_unique': 'F-END', 'nom_fournisseur': 'Endesa France'},
  {'key': 'Enercoop', 'code_unique': 'F-ENC', 'nom_fournisseur': 'Enercoop'},
  {'key': 'Energem', 'code_unique': 'F-EGM', 'nom_fournisseur': 'énergem'},
  {'key': 'ENERGIE_DICI', 'code_unique': 'F-EDI', 'nom_fournisseur': 'Energie d\'ici'},
  {'key': 'EDS', 'code_unique': 'F-EST', 'nom_fournisseur': 'Energies du Santerre'},
  {'key': 'Engie E&C', 'code_unique': 'F-ENG', 'nom_fournisseur': 'Engie'},
  {'key': 'Engie Pro', 'code_unique': 'F-ENP', 'nom_fournisseur': 'Engie Pro'},
  {'key': 'ENI', 'code_unique': 'F-ENI', 'nom_fournisseur': 'Eni'},
  {'key': 'Enovos', 'code_unique': 'F-ENO', 'nom_fournisseur': 'Enovos'},
  {'key': 'Electricite_de_Strasbourg', 'code_unique': 'F-ESX', 'nom_fournisseur': 'ÉS'},
  {'key': 'GEG', 'code_unique': 'F-GEG', 'nom_fournisseur': 'Gaz électricité de Grenoble (GEG)'},
  {'key': 'GazEuropeen', 'code_unique': 'F-GEU', 'nom_fournisseur': 'GAZ EUROPEEN'},
  {'key': 'GazelEnergie', 'code_unique': 'F-GZE', 'nom_fournisseur': 'GAZEL ENERGIE'},
  {'key': 'Gazena', 'code_unique': 'F-GZN', 'nom_fournisseur': 'Gazena'},
  {'key': 'GEDIA', 'code_unique': 'F-GES', 'nom_fournisseur': 'Gedia Energies & Services'},
  {'key': 'Hellio', 'code_unique': 'F-HEL', 'nom_fournisseur': 'Héllio'},
  {'key': 'HydroNext', 'code_unique': 'F-HYD', 'nom_fournisseur': 'Hydronext'},
  {'key': 'IBERDROLA', 'code_unique': 'F-IBD', 'nom_fournisseur': 'Iberdrola'},
  {'key': 'ILEK', 'code_unique': 'F-ILK', 'nom_fournisseur': 'ilek'},
  {'key': 'JPME', 'code_unique': 'F-JPM', 'nom_fournisseur': 'JPME'},
  {'key': 'la_bellenergie', 'code_unique': 'F-LBE', 'nom_fournisseur': 'La bellenergie'},
  {'key': 'LLUM', 'code_unique': 'F-LLU', 'nom_fournisseur': 'LLUM'},
  {'key': 'LUCIA', 'code_unique': 'F-LCI', 'nom_fournisseur': 'LUCIA'},
  {'key': 'MET-France', 'code_unique': 'F-MET', 'nom_fournisseur': 'MET France'},
  {'key': 'mint-energie', 'code_unique': 'F-MNT', 'nom_fournisseur': 'Mint Energie'},
  {'key': 'octopus-energy', 'code_unique': 'F-OCT', 'nom_fournisseur': 'Octopus-energy'},
  {'key': 'OHM_GRANDS_COMPTES', 'code_unique': 'F-OEG', 'nom_fournisseur': 'Ohm Energie Grands Comptes'},
  {'key': 'OHM_MIDDLE_MARKET', 'code_unique': 'F-OEM', 'nom_fournisseur': 'Ohm Energie Middle Market'},
  {'key': 'OHM', 'code_unique': 'F-OES', 'nom_fournisseur': 'Ohm Energie Soho'},
  {'key': 'Primeo', 'code_unique': 'F-PRM', 'nom_fournisseur': 'Primeo Energie'},
  {'key': 'Proxelia', 'code_unique': 'F-PRX', 'nom_fournisseur': 'Proxelia'},
  {'key': 'Racine_Energie', 'code_unique': 'F-RAC', 'nom_fournisseur': 'Racine Énergie'},
  {'key': 'Region_Gaz', 'code_unique': 'F-RGZ', 'nom_fournisseur': 'Régiongaz'},
  {'key': 'SELFEE', 'code_unique': 'F-SLF', 'nom_fournisseur': 'Selfee'},
  {'key': 'Selia', 'code_unique': 'F-SEL', 'nom_fournisseur': 'SELIA'},
  {'key': 'Solvay', 'code_unique': 'F-SES', 'nom_fournisseur': 'Solvay Energy Services'},
  {'key': 'Synelva', 'code_unique': 'F-SYN', 'nom_fournisseur': 'SYNELVA'},
  {'key': 'TDE', 'code_unique': 'F-TOT', 'nom_fournisseur': 'TotalEnergies'},
  {'key': 'Urban_Solar', 'code_unique': 'F-USE', 'nom_fournisseur': 'Urban Solar Energy'},
  {'key': 'Valoris', 'code_unique': 'F-VLE', 'nom_fournisseur': 'Valoris Energie'},
  {'key': 'Vattenfall', 'code_unique': 'F-VC5', 'nom_fournisseur': 'Vattenfall'},
  {'key': 'Volterres', 'code_unique': 'F-VLT', 'nom_fournisseur': 'Volterres'},
  {'key': 'Wekiwi', 'code_unique': 'F-WKW', 'nom_fournisseur': 'Wekiwi'},
  {'key': 'yeli', 'code_unique': 'F-YEL', 'nom_fournisseur': 'Yéli'},
  {'key': 'Yenka', 'code_unique': 'F-YNK', 'nom_fournisseur': 'Yenka Energie'},
  { 'key': 'SaveEnergies', 'code_unique': 'F-SAV', 'nom_fournisseur': 'SAVE' },
  {'key': 'GME', 'code_unique': 'F-GME', 'nom_fournisseur': 'GME'}
],
      rules: {
        isPositiveNumb: (v) =>
          /^[0-9]\d*$/.test(v) ||
          "La valeur doit etre un entier strictement supérieur à 0",
        required(fieldName) {
          return (value) => {
            if (typeof value == "number") {
              return value >= 0 || `Veuillez saisir ${fieldName}`;
            } else {
              return (
                (value?.toString().length > 0 && !!value) ||
                `Veuillez saisir ${fieldName}`
              );
            }
          };
        },
        siretLength: (v) => v.length == 14 || "Le siret doit comporter 14 chiffres",
        isMonthCorrect: (v) =>
          (v >= 1 && v <= 12) || "Le mois doit etre compris entre 1 et 12 ",
        isNumber: (v) =>
          v.match(/^[0-9]+$/) != null || "Ce champ n'accepte que les chiffres",
        compteurElecLength: (v) =>
          v.length == 14 || "Le RAE / PDL est une suite de 14 chiffres",
        isGazCompteur: (v) =>
          v.match(/^(GI)[0-9]{6}$/) ||
          (v.length == 14 && v.match(/^[0-9]+$/) != null) ||
          "Le numéro PCE/ PDL doit commencer par (GI) ou comporter 14 chiffres",
        phoneLength: (v) =>
          v.length == 10 || "Le numéro de téléphone est une suite de 10 chiffres",
        phoneisNumber: (v) =>
          v.match(/^[0-9]+$/) != null || "Ce champ n'accepte que les chiffres",
        margeMaxMin: (v) =>
          (v <= 45 && v >= 2) || "La marge doit être comprise entre 2 et 45",
        margeMaxMinJpme: (v) => v >= 0 || "La marge doit être superieur à 0",
        pourcentageEcrete: (v) =>
          (v <= 100 && v >= 1) ||
          "La valeur de pré-écrêté doit être comprise entre 1 et 100",
        Length: (v) => v.length > 0 || "Veuillez saisir un type d'offre",
        isBetweenRangeNumber: (v) =>
          (v >= 2 && v <= 45) || "La valeur saisie doit etre comprise entre 2 et 45",

        emailRules: (v) => (!!v && /.+@.+\.+.+/.test(v)) || "E-mail invalide",
      },
      required(fieldName) {
        return (value) => {
          if (typeof value == "number") {
            return value >= 0 || `Veuillez saisir ${fieldName}`;
          } else {
            return (
              (value?.toString().length > 0 && !!value) || `Veuillez saisir ${fieldName}`
            );
          }
        };
      },
      minDebutContrat: new Date().toISOString().substr(0, 10),
      minDebutFinContrat: new Date().toISOString().substr(0, 10),
      maxDateFinContrat: new Date(new Date().getFullYear() + 5 + "-" + 12 + "-" + 31)
        .toISOString()
        .substr(0, 10),
      maxDateDebutContrat: new Date(new Date().getFullYear() + 5 + "-" + 11 + "-30")
        .toISOString()
        .substr(0, 10),
    };
  },
  watch: {
    "autreFournisseur.DUREE": function () {
      if (this.autreFournisseur.multiYear) {
        this.syncAnneesAutreFournisseur();
      }
    },
    resultatJpmeApi: function (newValue) {},
    marge: function (newValue) {
      if (newValue != null)
        for (const element of this.listDonnerCotation) {
          element.marge = newValue;
        }
    },
    margeAbo: function (newValue) {
      if (newValue != null && newValue != "0")
        for (const element of this.listDonnerCotation) {
          element.margeAbo = newValue;
        }
    },
    listCompteurSelected: function (newValue) {
      let array = [];
      if (this.tousLesAutreFournisseur.length == 0) {
        array = [...newValue];
        this.listCompteurSelectedComputedFournisseurActuelle = array;
      } else {
        for (let i = 0; i < newValue.length; i++) {
          let ispresent = this.tousLesAutreFournisseur.some((el) => {
            return el.numCompteur == newValue[i];
          });
          let isPresentActuelle = this.tousLesAutreFournisseur.some(
            (el) => el.numCompteur == newValue[i] && el.typeFournisseur == "Actuelle"
          );
          if (ispresent == false || isPresentActuelle == false) {
            array.push(newValue[i]);
          }
        }
        this.listCompteurSelectedComputedFournisseurActuelle = array;
      }
    },
    tousLesAutreFournisseur: {
      handler: function (newValue) {
        let array = [];
        for (let i = 0; i < this.listCompteurSelected.length; i++) {
          if (this.tousLesAutreFournisseur.length == 0) {
            array.push(this.listCompteurSelected[i]);
          } else {
            let ispresent = this.tousLesAutreFournisseur.some((el) => {
              return el.numCompteur == this.listCompteurSelected[i];
            });
            let isPresentActuelle = this.tousLesAutreFournisseur.some(
              (el) =>
                el.numCompteur == this.listCompteurSelected[i] &&
                el.typeFournisseur == "Actuelle"
            );
            if (ispresent == false || isPresentActuelle == false) {
              array.push(this.listCompteurSelected[i]);
            }
          }
        }
        this.listCompteurSelectedComputedFournisseurActuelle = array;
      },
      deep: true,
    },
  },
  created() {
    try {
      if (this.$route.query.siret) {
        this.valueRechercheSiret = this.$route.query.siret;
        this.siret = this.$route.query.siret;
        this.listSociete = [this.siret];
      }
    } catch (error) {
      console.log(error);
    }
    if (this.isHistorique) {
      this.idHistorique = this.$route.query.idHistorique;
      this.getHistoriqueInitialisation();
    }
  },

  methods: {
    applyDatesToAllCompteurs() {
      for (const element of this.listDonnerCotation) {
        if (this.dateDebut) element.dateDebut = this.dateDebut;
        if (this.dateFin) element.dateFin = this.dateFin;
      }
    },
    getHistoriqueInitialisation() {
      const formData = new FormData();
      formData.append("historique_id", this.idHistorique);
      formData.append("token", this.getToken("token"));
      let arrayTemp = [];
      axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT +
          "getPreparationDesDoneesDeCotationElecHistoriques/",
        method: "POST",
        data: formData,
      }).then((responseData) => {

        if (responseData.data.result === "permission") {
          localStorage.setItem("vueAfficher", "particulier");
          localStorage.removeItem("vendeurName");
          localStorage.removeItem("typeUser");
          localStorage.removeItem("token");
          this.$router.push("/login");
        } else if (responseData.data.result == true) {
          let dataSociete = responseData.data.dataSociete;
          this.vraiSiret = true;
          this.scoreEllipro = dataSociete.scoreEllipro;
          this.scoreCreditSafe = dataSociete.scoreCreditSafe;
          this.listCompteur = responseData.data.listeCompteurSelected;
          this.listCompteurSelected = responseData.data.listeCompteurSelected;
          this.siret = dataSociete.siret;
          this.listDonnerCotation = responseData.data.listDonnerCotation;
          this.enedisRecherche = true
          this.dateDebut = responseData.data.infoDate.dateDebut;
          this.dateFin = responseData.data.infoDate.dateFin;
          this.marge = responseData.data.infoDate.marge;
          let propositionCompteur = [];
          for (let i = 0; i < this.listCompteurSelected.length; i++) {
            let listProposition = responseData.data.propositionCompteur[this.listCompteurSelected[i]];
            propositionCompteur.push({
              NumCompteur: this.listCompteurSelected[i],
              resultat: listProposition,
            });
          }

          this.tousLesAutreFournisseur = responseData.data.fournisseurAuxiliaireElec
          // liste de référence pour les filtres d'option tarifaire
          this.defaulttousLesAutreFournisseur = [...this.tousLesAutreFournisseur];
          for (var j = 0; j < this.tousLesAutreFournisseur.lenght; j++) {
            if (
              this.tousLesAutreFournisseur[j]["typeOffre"].indexOf(
                "pré-écrêté"
              ) != -1
            ) {
              if (
                this.tousLesAutreFournisseur[j]["typeOffre"].indexOf("%") !=
                -1
              ) {
                this.tousLesAutreFournisseur[j]["Classique"] = [""];
                this.tousLesAutreFournisseur[j]["preEcrete"] =
                  this.tousLesAutreFournisseur[j]["typeOffre"]
                    .split("pré-écrêté")[1]
                    .split("%")[0]
                    .replace(" ", "");
              } else {
                this.tousLesAutreFournisseur[j]["Classique"] = ["Classique"];
                this.tousLesAutreFournisseur[j]["preEcrete"] = "0";
              }
              this.tousLesAutreFournisseur[j]["typeOffre"] = "pré-écrêté";
            }
          }

          this.$emit("sendDataToParent", {
            infosCompteur: responseData.data.propositionCompteur,
            donneDeCotation: null,
            optionTarifaire: null,
            marge: this.marge,
            parametreCompteur: null,
            Propositions: propositionCompteur, //Propositions: res.data.result,
            SocieteData: dataSociete,
            enedisData: {},
            numCompteur: "",
            turpeData: "",
            taxeData: "",
            typeCompteur: "",
            fournisseurActuelle: "",
            selected: [],
            listCompteur: [...this.listCompteurSelected],
            donnerCompteur: {},
          });

          this.dialog = false;
          this.loading = false;
        } else if (responseData.data.result == false) {
          this.vraiSiret = false;
          this.loading = false;
          this.messageDialogeError =
            "Vérifiez que votre siret/raison social soit valide et que vous disposez d'une demande de cotation déjà acceptée";
          this.error = true;
        }
      });
    },
    AjouterFournisseurJpmePdf() {
      if (!(this.resultatJpmeApi?.data?.length > 0)) {
        this.$toast.error("Remplir les donner de prix avant l'ajout");
        // stop the function and don't complete the others instructions
        return;
      }
      if (this.$refs.formActuelle.validate() && this.resultatJpmeApi["data"].length > 0) {
        this.tousLesAutreFournisseur = this.tousLesAutreFournisseur.concat(
          this.resultatJpmeApi["data"]
        );
        this.resetFournisseurActuelle();
        this.$refs.formActuelle.resetValidation();
        this.openModalFornisseurActuelle = false;
        this.editFournisseur = false;
        this.autreFournisseur.numCompteur = "";
        this.annulerDonnerJpme();
        this.margeJpme = null;
        this.jpmeFileOuiNon = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.filePdfJpme = file;
      // Vous pouvez maintenant travailler avec `this.filePdfJpme`
    },
    annulerDonnerJpme() {
      this.filePdfJpme = null;
      this.resultatJpmeApi = {
        result: false,
        data: [],
      };
    },
    getDonnerJpme() {
      if (this.$refs.formJPMEFileUpload.validate()) {
        var formData = new FormData();
        formData.append("PDFfile", this.filePdfJpme);
        formData.append("parametreCompteur", this.autreFournisseur.parametreCompteur);
        formData.append("optionTarifaire", this.optionTarifaire);
        formData.append("marge", this.margeJpme);
        formData.append("numCompteur", this.autreFournisseur.numCompteur);
        formData.append("typeFournisseur", this.autreFournisseur.typeFournisseur);
        formData.append("token", this.getToken("token"));
        axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "executerJpme/",
          method: "POST",
          data: formData,
        })
          .then((res) => {
            this.resultatJpmeApi = res.data;
          })
          .catch((err) => {
            this.$toast.error("Erreur : Veuillez vérifier votre fichier PDF.");
          });
      }
    },
    filtrerAutreFournisseurParCompteur(numCompteur, parametreCompteur) {
      // affiche les fournisseurs du compteur pour ce parametreCompteur, sans toucher aux autres compteurs
      if (this.defaulttousLesAutreFournisseur.length == 0) {
        return;
      }
      const autresCompteurs = this.tousLesAutreFournisseur.filter(
        (frn) => frn.numCompteur != numCompteur
      );
      const duCompteur = this.defaulttousLesAutreFournisseur.filter(
        (frn) => frn.numCompteur == numCompteur && frn.parametreCompteur == parametreCompteur
      );
      this.tousLesAutreFournisseur = [...autresCompteurs, ...duCompteur];
    },
    changeOptionCalculeBtinf(obj, newParam) {
      this.filtrerAutreFournisseurParCompteur(obj.numCompteur, newParam);
      try {
        this.toutLesDonneesEnedis = this.dataEnedisComplexParCompteur[obj.numCompteur][
          newParam
        ];
        this.toutLesDonneesEnedis.parametreDeCompteur = obj.parametreCompteur;
        const index = this.listDonnerCotation.findIndex(
          (item) => item.numCompteur === obj.numCompteur
        );
        this.listDonnerCotation.splice(index, 1);
        const newDonneDeCotation = this.remplireDataCotationComplex(
          obj.numCompteur,
          false,
          this.dataAutreFournisseurComplexParCompteur[obj.numCompteur][newParam]
        );
        this.listDonnerCotation.splice(index, 0, newDonneDeCotation);
      } catch (err) {
        console.log(err);
      }
      this.renitialiserLaListeDeResultat();
    },
    openModalFornisseurActuelleFnc() {
      this.$refs.formGeneral.validate();
      if (this.$refs.formGeneral.validate()) {
        this.selectedCompteursMulti = [];
        this.dialogStep = 1;
        this.prixParGroupe = {};
        this.erreurMultiYear = "";
        this.cacheAnneesAutreFournisseur = {};
        this.openModalFornisseurActuelle = true;
        this.margeJpme = this.marge;
      }
    },
    createEmptyGroupPrix(param) {
      const fields = this.fieldsPerParametre[param];
      const group = { typeCapa: 'CAPA' };
      if (fields) {
        for (const f of fields.prix) group[f] = null;
        for (const f of fields.capa) group[f] = null;
      }
      group.years = this.autreFournisseur.multiYear
        ? this.getAnneesOffre().map((annee) => this.nouvelleAnneeGroupe(param, annee, group))
        : [];
      return group;
    },
    getAnneesOffre() {
      // de la date de début de l'offre jusqu'à date de début + durée de contrat
      const duree = parseInt(this.autreFournisseur.DUREE);
      if (!this.dateDebut || !duree || duree <= 0) {
        return [];
      }
      const debut = this.$dayjs(this.dateDebut);
      const fin = debut.add(duree, "month").subtract(1, "day");
      const annees = [];
      for (let annee = debut.year(); annee <= fin.year(); annee++) {
        annees.push(annee);
      }
      return annees;
    },
    nouvelleAnneeDepuis(source, fields, annee) {
      // année pré-remplie avec les valeurs saisies pour l'offre simple
      const year = { annee: annee, CEE: this.autreFournisseur.CEE, ABO: this.autreFournisseur.ABO };
      if (fields) {
        fields.prix.concat(fields.capa).forEach((field) => {
          year[field] = source[field] === undefined ? null : source[field];
        });
      }
      return year;
    },
    nouvelleAnneeAutreFournisseur(annee) {
      return this.nouvelleAnneeDepuis(this.autreFournisseur,
        this.fieldsPerParametre[this.autreFournisseur.parametreCompteur], annee);
    },
    nouvelleAnneeGroupe(param, annee, group) {
      return this.nouvelleAnneeDepuis(group || this.prixParGroupe[param] || {}, this.fieldsPerParametre[param], annee);
    },
    syncAnnees(years, cacheKey, fabrique) {
      // on garde les prix déjà saisis, même pour une année retirée puis remise
      // (ex: durée tapée chiffre par chiffre 2 -> 3 -> 36)
      if (!this.cacheAnneesAutreFournisseur[cacheKey]) {
        this.cacheAnneesAutreFournisseur[cacheKey] = {};
      }
      const cache = this.cacheAnneesAutreFournisseur[cacheKey];
      (years || []).forEach((year) => {
        cache[parseInt(year.annee)] = year;
      });
      return this.getAnneesOffre().map((annee) =>
        cache[annee] ? { ...cache[annee], annee: annee } : fabrique(annee)
      );
    },
    syncAnneesAutreFournisseur() {
      if (this.editFournisseur) {
        this.autreFournisseur.years = this.syncAnnees(this.autreFournisseur.years, "edit",
          (annee) => this.nouvelleAnneeAutreFournisseur(annee));
      } else {
        Object.keys(this.prixParGroupe).forEach((param) => {
          this.$set(this.prixParGroupe[param], "years", this.syncAnnees(this.prixParGroupe[param].years, param,
            (annee) => this.nouvelleAnneeGroupe(param, annee)));
        });
      }
    },
    remplirAnneesVides(years, fabrique) {
      // les cases vides reprennent les valeurs de l'offre simple
      (years || []).forEach((year) => {
        const valeurs = fabrique(year.annee);
        Object.keys(valeurs).forEach((cle) => {
          if (year[cle] === null || year[cle] === undefined || year[cle] === "") {
            year[cle] = valeurs[cle];
          }
        });
      });
    },
    toggleMultiYear(value) {
      this.erreurMultiYear = "";
      if (value) {
        this.syncAnneesAutreFournisseur();
        if (this.editFournisseur) {
          this.remplirAnneesVides(this.autreFournisseur.years, (annee) => this.nouvelleAnneeAutreFournisseur(annee));
        } else {
          Object.keys(this.prixParGroupe).forEach((param) => {
            this.remplirAnneesVides(this.prixParGroupe[param].years, (annee) => this.nouvelleAnneeGroupe(param, annee));
          });
        }
      }
    },
    verifierAnneesAutreFournisseur() {
      const listes = this.editFournisseur
        ? [this.autreFournisseur.years]
        : Object.keys(this.prixParGroupe).map((param) => this.prixParGroupe[param].years);
      if (listes.length == 0 || listes.some((years) => !years || years.length == 0)) {
        return "Veuillez saisir la date de début et la durée de contrat pour afficher les années de l'offre";
      }
      return "";
    },
    onMultiCompteurChanged() {
      const newGroups = {};
      for (const numCompteur of this.selectedCompteursMulti) {
        const item = this.listDonnerCotation.find(c => c.numCompteur === numCompteur);
        if (item) {
          const param = item.parametreCompteur;
          if (!newGroups[param]) {
            newGroups[param] = this.prixParGroupe[param] || this.createEmptyGroupPrix(param);
          }
        }
      }
      this.prixParGroupe = newGroups;
    },
    selectAllCompteurs() {
      const source =
        this.autreFournisseur.typeFournisseur == "Actuelle"
          ? this.listCompteurSelectedComputedFournisseurActuelle
          : this.listCompteurSelected;
      this.selectedCompteursMulti = [...source];
      this.onMultiCompteurChanged();
    },
    unselectAllCompteurs() {
      this.selectedCompteursMulti = [];
      this.onMultiCompteurChanged();
    },
    validateSelectionCompteur(value) {
      if (value.length < 1) {
        return "Vous devez sélectionner au moins un élément.";
      }
      return true;
    },
    isDisabledMesures(compteurLine) {
      if (compteurLine?.resultatEnedis?.mesuresInfo[0].nbrMonth >= 8) {
        return true;
      } else {
        return false;
      }
    },
    SupprimerCompteurPDL() {
      if (this.listCompteurSelected.length > 1) {
        this.tousLesAutreFournisseur.forEach((element, index) => {
          if (
            this.listCompteurSelected[this.listCompteurSelected.length - 1] ==
            element.numCompteur
          ) {
            this.tousLesAutreFournisseur.splice(index, 1);
          }
        });

        this.listCompteurSelected.splice(this.listCompteurSelected.length - 1, 1);
      }
      this.compteurPDL--;
    },
    incrementCompteurPDL() {
      if (this.listCompteur[this.compteurPDL] != this.listCompteur.slice(-1)) {
        this.compteurPDL++;
        this.listCompteurSelected[this.compteurPDL] = this.listCompteur[this.compteurPDL];
      }
    },
    getHistoriqueInitialisation() {
      const formData = new FormData();
      formData.append("historique_id", this.idHistorique);
      formData.append("token", this.getToken("token"));
      let arrayTemp = [];
      axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT +
          "getPreparationDesDoneesDeCotationElecHistoriques/",
        method: "POST",
        data: formData,
      }).then((responseData) => {

        if (responseData.data.result === "permission") {
          localStorage.setItem("vueAfficher", "particulier");
          localStorage.removeItem("vendeurName");
          localStorage.removeItem("typeUser");
          localStorage.removeItem("token");
          this.$router.push("/login");
        } else if (responseData.data.result == true) {
          let dataSociete = responseData.data.dataSociete;
          this.vraiSiret = true;
          this.scoreEllipro = dataSociete.scoreEllipro;
          this.scoreCreditSafe = dataSociete.scoreCreditSafe;
          this.listCompteur = responseData.data.listeCompteurSelected;
          this.listCompteurSelected = responseData.data.listeCompteurSelected;
          this.siret = dataSociete.siret;
          this.listDonnerCotation = responseData.data.listDonnerCotation;
          this.enedisRecherche = true
          this.dateDebut = responseData.data.infoDate.dateDebut;
          this.dateFin = responseData.data.infoDate.dateFin;
          this.marge = responseData.data.infoDate.marge;
          let propositionCompteur = [];
          for (let i = 0; i < this.listCompteurSelected.length; i++) {
            let listProposition = responseData.data.propositionCompteur[this.listCompteurSelected[i]];
            propositionCompteur.push({
              NumCompteur: this.listCompteurSelected[i],
              resultat: listProposition,
            });
          }

          this.tousLesAutreFournisseur = responseData.data.fournisseurAuxiliaireElec
          // liste de référence pour les filtres d'option tarifaire
          this.defaulttousLesAutreFournisseur = [...this.tousLesAutreFournisseur];
          for (var j = 0; j < this.tousLesAutreFournisseur.lenght; j++) {
            if (
              this.tousLesAutreFournisseur[j]["typeOffre"].indexOf(
                "pré-écrêté"
              ) != -1
            ) {
              if (
                this.tousLesAutreFournisseur[j]["typeOffre"].indexOf("%") !=
                -1
              ) {
                this.tousLesAutreFournisseur[j]["Classique"] = [""];
                this.tousLesAutreFournisseur[j]["preEcrete"] =
                  this.tousLesAutreFournisseur[j]["typeOffre"]
                    .split("pré-écrêté")[1]
                    .split("%")[0]
                    .replace(" ", "");
              } else {
                this.tousLesAutreFournisseur[j]["Classique"] = ["Classique"];
                this.tousLesAutreFournisseur[j]["preEcrete"] = "0";
              }
              this.tousLesAutreFournisseur[j]["typeOffre"] = "pré-écrêté";
            }
          }

          this.$emit("sendDataToParent", {
            infosCompteur: responseData.data.propositionCompteur,
            donneDeCotation: null,
            optionTarifaire: null,
            parametreCompteur: null,
            Propositions: propositionCompteur, //Propositions: res.data.result,
            SocieteData: dataSociete,
            enedisData: {},
            numCompteur: "",
            turpeData: "",
            taxeData: "",
            typeCompteur: "",
            fournisseurActuelle: "",
            selected: [],
            listCompteur: [...this.listCompteurSelected],
            donnerCompteur: {},
          });

          this.dialog = false;
          this.loading = false;
        } else if (responseData.data.result == false) {
          this.vraiSiret = false;
          this.loading = false;
          this.messageDialogeError =
            "Vérifiez que votre siret/raison social soit valide et que vous disposez d'une demande de cotation déjà acceptée";
          this.error = true;
        }
      });
    },
    renitialiserLaListeDeResultat() {
      this.$emit("sendDataToParent", {
        donneDeCotation: [],
        optionTarifaire: "",
        marge:"",
        parametreCompteur: "",
        Propositions: [],
        SocieteData: "",
        enedisData: "",
        numCompteur: "",
        turpeData: "",
        taxeData: "",
        typeCompteur: "",
        fournisseurActuelle: "",
        selected: [],
        listCompteur: [],
        donnerCompteur: null,
        date_debut: "",
      });
    },
    resetForm() {
      this.listBodyArray.splice(0);
      this.listCompteurSelected.splice(0);
      this.compteurPDL = 0;
      this.renitialiserLaListeDeResultat();
      this.fournisseurActuelle = false;
      //donner generale
      this.openModalFornisseurActuelle = false;
      this.vraiSiret = false;
      this.resultatEnedisMesure = false;
      this.resultatEnedisTechnique = false;
      this.enedisRecherche = false;
      this.siret = "";
      this.listSociete = [];
      this.listCompteur = [];
      this.parametreCompteur = "";
      this.scoreEllipro = "";
      this.scoreCreditSafe = "";
      //donner de cotation
      this.marge = "";
      this.margeAbo = "";
      this.dateDebut = "";
      this.dateFin = "";
      //fornisseur actuelle

      this.openModalFornisseurActuelle = false;
      this.autreFournisseur.typeFournisseur = "Fournisseur";
      this.autreFournisseur.turpeInclus = "non";
      this.autreFournisseur.ajoutMarge = false;
      this.autreFournisseur.Classique = ["Classique"];
      this.autreFournisseur.preEcrete = "0";
      this.autreFournisseur.fournisseur = null;
      this.autreFournisseur.typeOffre = "";
      this.autreFournisseur.prixHPH = null;
      this.autreFournisseur.prixHCH = null;
      this.autreFournisseur.prixHPE = null;
      this.autreFournisseur.prixHCE = null;
      this.autreFournisseur.prixHP = null;
      this.autreFournisseur.prixHC = null;
      this.autreFournisseur.prixBASE = null;
      this.autreFournisseur.prixPOINTE = null;
      this.autreFournisseur.typeCapa = "CAPA";
      this.autreFournisseur.capaHPH = null;
      this.autreFournisseur.capaHCH = null;
      this.autreFournisseur.capaHPE = null;
      this.autreFournisseur.capaHCE = null;
      this.autreFournisseur.capaHP = null;
      this.autreFournisseur.capaHC = null;
      this.autreFournisseur.capaBASE = null;
      this.autreFournisseur.capaPOINTE = null;
      this.autreFournisseur.CEE = null;
      this.autreFournisseur.ABO = null;
      this.autreFournisseur.prixEnergieVerte = false;
      this.autreFournisseur.isEnergieVerte = null,
      this.autreFournisseur.DUREE = null;
      this.autreFournisseur.parametreCompteur = "";
      this.autreFournisseur.multiYear = false;
      this.autreFournisseur.years = [];
      this.erreurMultiYear = "";
      this.cacheAnneesAutreFournisseur = {};
    },
    resetFournisseurActuelle() {
      this.renitialiserLaListeDeResultat();
      this.$refs.formActuelle.resetValidation();
      this.editFournisseur = false;
      this.indexFournisseurEdited = -1;
      this.autreFournisseur.typeFournisseur = "Fournisseur";
      this.autreFournisseur.numCompteur = "";
      this.autreFournisseur.turpeInclus = "non";
      this.autreFournisseur.ajoutMarge = false;
      this.autreFournisseur.Classique = ["Classique"];
      this.autreFournisseur.preEcrete = "0";
      this.autreFournisseur.fournisseur = null;
      this.autreFournisseur.typeOffre = "";
      this.autreFournisseur.prixHPH = null;
      this.autreFournisseur.prixHCH = null;
      this.autreFournisseur.prixHPE = null;
      this.autreFournisseur.prixHCE = null;
      this.autreFournisseur.prixHP = null;
      this.autreFournisseur.prixHC = null;
      this.autreFournisseur.prixBASE = null;
      this.autreFournisseur.prixPOINTE = null;
      this.autreFournisseur.typeCapa = "CAPA";
      this.autreFournisseur.capaHPH = null;
      this.autreFournisseur.capaHCH = null;
      this.autreFournisseur.capaHPE = null;
      this.autreFournisseur.capaHCE = null;
      this.autreFournisseur.capaHP = null;
      this.autreFournisseur.capaHC = null;
      this.autreFournisseur.capaBASE = null;
      this.autreFournisseur.capaPOINTE = null;
      this.autreFournisseur.CEE = null;
      this.autreFournisseur.ABO = null;
      this.autreFournisseur.prixEnergieVerte = null;
      this.autreFournisseur.isEnergieVerte = false;
      this.autreFournisseur.DUREE = null;
      this.autreFournisseur.parametreCompteur = "";
      this.autreFournisseur.multiYear = false;
      this.autreFournisseur.years = [];
      this.erreurMultiYear = "";
      this.cacheAnneesAutreFournisseur = {};
      this.openModalFornisseurActuelle = false;
      this.jpmeFileOuiNon = false;
      this.selectedCompteursMulti = [];
      this.dialogStep = 1;
      this.prixParGroupe = {};
    },
    dateFormatSlach(date) {
      return date.split("-").reverse().join("/");
    },
    dateFormatMinus(date) {
      return date.split("/").reverse().join("-");
    },
    isRangeDateValide(date) {
      if (this.dateFin != "" && this.dateDebut != "" && this.dateFin < this.dateDebut) {
        switch (date) {
          case "Début":
            return "la date de début doit etre inférieure à la date de fin";
            break;
          case "Fin":
            return "la date de fin doit etre supérieur à la date de début";
            break;

          default:
            break;
        }
      }
    },
    formatDate(date) {
      return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join("/");
    },
    isValidDate(formatDate, minDate, maxDate) {
      return (date) => {
        var tmpdate = this.dateFormatMinus(date);
        if (!date) {
          return "Veuillez saisir une date valide";
        }
        if (moment(tmpdate).isBefore(minDate)) {
          return `La date doit être supérieure  au ${this.dateFormatSlach(minDate)}.`;
        }
        if (moment(tmpdate).isAfter(maxDate)) {
          return `La date limite de fin de contrat est: ${this.dateFormatSlach(
            maxDate
          )}.`;
        }
        return true;
      };
    },
    changeOptionTarifaire(obj) {
      var optionTarifaire = obj.optionTarifaire;
      ////////////////
      if (obj.resultatEnedisMesure == false && obj.resultatEnedisTechnique == false) {
        if (optionTarifaire == "BTINFMUDT") {
          obj.parametreCompteur = "C5HP";
          obj.typeTraitementCompteur = "simple";
        }
        if (optionTarifaire == "BTINFLU" || optionTarifaire == "BTINFCUST") {
          obj.parametreCompteur = "C5BASE";
          obj.typeTraitementCompteur = "simple";
        }
        if (["BTSUPCU4", "BTSUPLU4"].includes(optionTarifaire)) {
          obj.parametreCompteur = "C4";
          obj.typeTraitementCompteur = "simple";
        }
        if (optionTarifaire == "BTINFCU4") {
          obj.parametreCompteur = "C5BASE";
          obj.typeTraitementCompteur = "complex";
        }
        if (optionTarifaire == "BTINFMU4") {
          obj.parametreCompteur = "C5HP";
          obj.typeTraitementCompteur = "complex";
        }
        if (["HTACU5", "HTACUPM5", "HTALU5", "HTALUPM5"].includes(optionTarifaire)) {
          obj.parametreCompteur = "C3";
          obj.typeTraitementCompteur = "simple";
        }
      }
      if (
        (optionTarifaire != "BTINFCU4" && optionTarifaire != "BTINFMU4") ||
        !this.dataEnedisComplexParCompteur[obj.numCompteur]
      ) {
        // compteur simple ou sans données Enedis complexes : simple filtre sur le parametreCompteur
        this.filtrerAutreFournisseurParCompteur(obj.numCompteur, obj.parametreCompteur);
      } else {
        // on retire les fournisseurs de ce compteur, remplireDataCotationComplex remet ceux de l'option choisie
        this.tousLesAutreFournisseur = this.tousLesAutreFournisseur.filter(
          (frn) => frn.numCompteur != obj.numCompteur
        );
        this.toutLesDonneesEnedis = this.dataEnedisComplexParCompteur[obj.numCompteur][
          obj.parametreCompteur
        ];
        this.toutLesDonneesEnedis.parametreDeCompteur = obj.parametreCompteur;
        try {
          const index = this.listDonnerCotation.findIndex(
            (item) => item.numCompteur === obj.numCompteur
          );
          this.listDonnerCotation.splice(index, 1);
          const newDonneDeCotation = this.remplireDataCotationComplex(
            obj.numCompteur,
            false,
            this.dataAutreFournisseurComplexParCompteur[obj.numCompteur][
              obj.parametreCompteur
            ]
          );
          this.listDonnerCotation.splice(index, 0, newDonneDeCotation);
        } catch (err) {
          console.log(err);
        }
      }
      this.renitialiserLaListeDeResultat();
    },
    async getListeCompteurs() {
      let resultApi;
      this.compteurPDL = 0;
      this.$refs.formeSiret.validate();
      if (this.$refs.formeSiret.validate()) {
        this.dialog = true;
        this.loading = true;
        this.error = false;
        this.dateDebut = "";
        this.dateFin = "";
        this.marge = "";
        this.margeAbo = "0";
        this.listCompteur = [];
        this.listCompteurSelected = [];
        this.listDonnerCotation = [];
        this.tousLesAutreFournisseur = [];
        this.defaulttousLesAutreFournisseur = [];
        this.messageDialogeError = "";
        this.messageDialogeSucces = "";
        this.siret = this.valueRechercheSiret;
        this.renitialiserLaListeDeResultat();
        var formData = new FormData();
        formData.append("value", this.siret);
        formData.append("token", this.getToken("token"));
        await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getListCompteurElecParSiret/",
          method: "POST",
          data: formData,
        })
          .then((res) => {
            const responseData = res.data;
            resultApi = res.data;
            if (responseData.result === "permission") {
              localStorage.setItem("vueAfficher", "particulier");
              localStorage.removeItem("vendeurName");
              localStorage.removeItem("typeUser");
              localStorage.removeItem("token");
              this.$router.push("/login");
            } else if (responseData.result == true) {
              if (responseData.compteur.length <= 0) {
                this.loading = false;
                this.messageDialogeError =
                  "Vous n'avez aucun compteur associé à ce siret/raison sociale";
                this.error = true;
              }
              this.vraiSiret = true;
              console.log(responseData)
              this.scoreEllipro = responseData.scoreEllipro;
              this.ceeExonere = responseData.cee;
              this.codeNaf = responseData.codeNaf;
              this.raison = responseData.raison;
              this.scoreCreditSafe = responseData.scoreCreditSafe;
              this.listCompteur = responseData.compteur;
              this.siret = responseData.siret;
              this.dialog = false;
              this.loading = false;
            } else if (responseData.result == false) {
              this.vraiSiret = false;
              this.loading = false;
              this.messageDialogeError =
                "Vérifiez que votre siret/raison social soit valide et que vous disposez d'une demande de cotation déjà acceptée";
              this.error = true;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.messageDialogeError =
              "Il semble qu'une erreur soit survenue ! Veuillez réessayer plus tard ";
            this.error = true;
            console.log(error);
          });
      }
      return resultApi;
    },

    async getAllConsommation() {
      if (!this.$refs.formGetConsommation.validate()) {
        return false;
      }
      this.marge = "";
      this.margeAbo = "";
      this.optionTarifaire = "";
      this.parametreCompteur = "";
      this.autreFournisseur.parametreCompteur = "";
      this.listBodyArray = [];
      this.listDonnerCotation = [];
      this.tousLesAutreFournisseur = [];
      this.defaulttousLesAutreFournisseur = [];
      this.renitialiserLaListeDeResultat();
      this.enedisRecherche = false;
      for (let i = 0; i < this.listCompteurSelected.length; i++) {
        var formData = new FormData();
        formData.append("numCompteur", this.listCompteurSelected[i]);
        formData.append("token", this.getToken("token"));
        await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getToutLesDonneesParCompteurEnedis/",
          method: "POST",
          data: formData,
        })
          .then(async (res) => {
            if (res.data.toutLesDonneesEnedis.result === "permission") {
              localStorage.removeItem("vendeurName");
              localStorage.removeItem("typeUser");
              localStorage.removeItem("token");
              this.$router.push("/login");
            }
            if (res.data.toutLesDonneesEnedis.typeCompteurTraitemant == "simple") {
              this.toutLesDonneesEnedis = res.data.toutLesDonneesEnedis;
              let data = res.data;
              await this.remplireDataCotationSimple(this.listCompteurSelected[i], data);
            } else {
              let FRNaux = [];
              this.dataEnedisComplexParCompteur[this.listCompteurSelected[i]] = {};
              this.dataAutreFournisseurComplexParCompteur[
                this.listCompteurSelected[i]
              ] = {};
              this.dataAutreFournisseurComplexParCompteur[this.listCompteurSelected[i]][
                "C5C4"
              ] = res.data.fournisseurAuxiliaireElec.filter(
                (item) => item.parametreCompteur === "C5C4"
              );
              this.dataAutreFournisseurComplexParCompteur[this.listCompteurSelected[i]][
                "C5HP"
              ] = res.data.fournisseurAuxiliaireElec.filter(
                (item) => item.parametreCompteur === "C5HP"
              );
              this.dataAutreFournisseurComplexParCompteur[this.listCompteurSelected[i]][
                "C5BASE"
              ] = res.data.fournisseurAuxiliaireElec.filter(
                (item) => item.parametreCompteur === "C5BASE"
              );

              this.dataEnedisComplexParCompteur[this.listCompteurSelected[i]]["C5C4"] =
                res.data.toutLesDonneesEnedis.dataEnedis[0];
              this.dataEnedisComplexParCompteur[this.listCompteurSelected[i]]["C5HP"] =
                res.data.toutLesDonneesEnedis.dataEnedis[1];
              this.dataEnedisComplexParCompteur[this.listCompteurSelected[i]]["C5BASE"] =
                res.data.toutLesDonneesEnedis.dataEnedis[2];
              if (
                this.dataEnedisComplexParCompteur[this.listCompteurSelected[i]]["C5C4"]
                  .donneTechniqueInfo[0].result == "valide"
              ) {
                let tarif = this.dataEnedisComplexParCompteur[
                  this.listCompteurSelected[i]
                ]["C5C4"].donneTechniqueInfo[0].data.typeCompteur;
                if (tarif == "BTINFCU4") {
                  this.toutLesDonneesEnedis = res.data.toutLesDonneesEnedis.dataEnedis[2];
                  FRNaux = this.dataAutreFournisseurComplexParCompteur[
                    this.listCompteurSelected[i]
                  ]["C5BASE"];
                } else {
                  this.toutLesDonneesEnedis = res.data.toutLesDonneesEnedis.dataEnedis[1];
                  FRNaux = this.dataAutreFournisseurComplexParCompteur[
                    this.listCompteurSelected[i]
                  ]["C5HP"];
                }
                let data = res.data;
                const newDonneDeCotation = await this.remplireDataCotationComplex(
                  this.listCompteurSelected[i],
                  res.data.autreData,
                  FRNaux
                );
                this.listDonnerCotation.push(newDonneDeCotation);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.enedisRecherche = false;
            this.errorEnedis = false;
            this.parametreCompteur = "";
          });
      }
    },
    remplireDataCotationSimple(numCompteur, data) {
      let arrayTemp = [];
      this.nbrMonth = this.toutLesDonneesEnedis.mesuresInfo[0].nbrMonth;
      if (
        this.toutLesDonneesEnedis.mesuresInfo[0].result == "notValide" &&
        this.toutLesDonneesEnedis.donneTechniqueInfo[0].result == "notValide"
      ) {
        this.errorEnedis = true;
      } else {
        this.errorEnedis = false;
        this.enedisRecherche = true;
      }
      let donneDeCotation = {};

      this.enedisRecherche = true;
      donneDeCotation.resultatEnedis = this.toutLesDonneesEnedis;
      arrayTemp = [...data.fournisseurAuxiliaireElec];
      this.defaulttousLesAutreFournisseur = [...data.fournisseurAuxiliaireElec];
      for (var j = 0; j < this.defaulttousLesAutreFournisseur.lenght; j++) {
        if (
          this.defaulttousLesAutreFournisseur[j]["typeOffre"].indexOf("pré-écrêté") != -1
        ) {
          if (this.defaulttousLesAutreFournisseur[j]["typeOffre"].indexOf("%") != -1) {
            this.defaulttousLesAutreFournisseur[j]["Classique"] = [""];
            this.defaulttousLesAutreFournisseur[j][
              "preEcrete"
            ] = this.defaulttousLesAutreFournisseur[j]["typeOffre"]
              .split("pré-écrêté")[1]
              .split("%")[0]
              .replace(" ", "");
          } else {
            this.defaulttousLesAutreFournisseur[j]["Classique"] = ["Classique"];
            this.defaulttousLesAutreFournisseur[j]["preEcrete"] = "0";
          }
          this.defaulttousLesAutreFournisseur[j]["typeOffre"] = "pré-écrêté";
        }
      }
      if (this.toutLesDonneesEnedis.mesuresInfo[0].result === "valide") {
        for (var j = 0; j < arrayTemp.length; j++) {
          if (arrayTemp[j]["typeOffre"].indexOf("pré-écrêté") != -1) {
            if (arrayTemp[j]["typeOffre"].indexOf("%") != -1) {
              arrayTemp[j]["Classique"] = [""];
              arrayTemp[j]["preEcrete"] = arrayTemp[j]["typeOffre"]
                .split("pré-écrêté")[1]
                .split("%")[0]
                .replace(" ", "");
            } else {
              arrayTemp[j]["Classique"] = ["Classique"];
              arrayTemp[j]["preEcrete"] = "0";
            }
            arrayTemp[j]["typeOffre"] = "pré-écrêté";
          }
          arrayTemp[j].optionTarifaire = this.toutLesDonneesEnedis.mesuresInfo[0][
            "dataParMonth"
          ][0]["typeCompteur"];
        }
        this.resultatEnedisMesure = true;
        if ("HP" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HP.somme;
        } else {
          donneDeCotation.CAHP = null;
        }
        if ("HC" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHC = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HC.somme;
        } else {
          donneDeCotation.CAHC = null;
        }
        if ("HPH" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHPH = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HPH.somme;
        } else {
          donneDeCotation.CAHPH = null;
        }
        if ("HCH" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHCH = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HCH.somme;
        } else {
          donneDeCotation.CAHCH = null;
        }
        if ("HPE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHPE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HPE.somme;
        } else {
          donneDeCotation.CAHPE = null;
        }
        if ("HCE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHCE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HCE.somme;
        } else {
          donneDeCotation.CAHCE = null;
        }
        if ("Pointe" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.Pointe.somme;
        }
        if ("POINTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.POINTE.somme;
        }
        if ("PTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.PTE.somme;
        }
        if (
          !("Pointe" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) &&
          !("POINTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) &&
          !("PTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne)
        ) {
          donneDeCotation.CAP = null;
        }
        if ("BASE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CABASE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.BASE.somme;
        } else {
          donneDeCotation.CABASE = null;
        }
      } else {
        this.resultatEnedisMesure = false;
        donneDeCotation.CAHP = null;
        donneDeCotation.CAHC = null;
        donneDeCotation.CAHPH = null;
        donneDeCotation.CAHCH = null;
        donneDeCotation.CAHPE = null;
        donneDeCotation.CAHCE = null;
        donneDeCotation.CAP = null;
        donneDeCotation.CAP = null;
        donneDeCotation.CABASE = null;
      }
      donneDeCotation["parametreCompteur"] =
        this.toutLesDonneesEnedis.parametreDeCompteur || "";
      if (this.toutLesDonneesEnedis.donneTechniqueInfo[0].result === "valide") {
        this.parametreCompteur = this.toutLesDonneesEnedis.parametreDeCompteur;
        if (
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur === "" ||
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur == "Résilié"
        ) {
          this.resultatEnedisTechnique = false;
        } else {
          this.resultatEnedisTechnique = true;
        }
        if (
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur != "" &&
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.kva != ""
        ) {
          donneDeCotation.optionTarifaire = this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur;
          donneDeCotation.puissanceSouscrite = this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.kva;
        } else {
          donneDeCotation.optionTarifaire = null;
          donneDeCotation.puissanceSouscrite = null;
        }
        // get tout les kva

        donneDeCotation.kvaHp =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HP || "";

        donneDeCotation.kvaHc =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HC || "";

        donneDeCotation.kvaHce =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HCE || "";

        donneDeCotation.kvaHpe =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HPE || "";

        donneDeCotation.kvaHch =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HCH || "";

        donneDeCotation.kvaHph =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HPH || "";

        donneDeCotation.kvaBase =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.BASE || "";

        donneDeCotation.kvaPte =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.PTE || "";
      } else {
        this.parametreCompteur = "";
        this.resultatEnedisTechnique = false;
        donneDeCotation.kvaHp = "";

        donneDeCotation.kvaHc = "";

        donneDeCotation.kvaHce = "";

        donneDeCotation.kvaHpe = "";

        donneDeCotation.kvaHch = "";

        donneDeCotation.kvaHph = "";

        donneDeCotation.kvaBase = "";

        donneDeCotation.kvaPte = "";
      }
      if (data.autreData.result == true) {
        const dateDebutFormatted = this.dateFormatMinus(data.autreData.dateDebut);
        const dateFinFormatted = this.dateFormatMinus(data.autreData.dateFin);
        this.dateDebut = dateDebutFormatted;
        this.dateFin = dateFinFormatted;
        donneDeCotation.dateDebut = dateDebutFormatted;
        donneDeCotation.dateFin = dateFinFormatted;
      }
      if (donneDeCotation.parametreCompteur == "C3") {
        donneDeCotation.sommeConsomation =
          donneDeCotation.CAHCH +
          donneDeCotation.CAHPH +
          donneDeCotation.CAHPE +
          donneDeCotation.CAHCE +
          donneDeCotation.CAP;
      } else if (donneDeCotation.parametreCompteur == "C4") {
        donneDeCotation.sommeConsomation =
          donneDeCotation.CAHCH +
          donneDeCotation.CAHPH +
          donneDeCotation.CAHPE +
          donneDeCotation.CAHCE;
      } else if (donneDeCotation.parametreCompteur == "C5HP") {
        donneDeCotation.sommeConsomation = donneDeCotation.CAHC + donneDeCotation.CAHP;
      } else if (donneDeCotation.parametreCompteur == "C5BASE") {
        donneDeCotation.sommeConsomation = donneDeCotation.CABASE || 0;
      }
      donneDeCotation.resultatEnedisTechnique = this.resultatEnedisTechnique;
      donneDeCotation.resultatEnedisMesure = this.resultatEnedisMesure;
      donneDeCotation["numCompteur"] = numCompteur;
      donneDeCotation["typeTraitementCompteur"] = "simple";
      arrayTemp.forEach((element) => {
        this.tousLesAutreFournisseur.push(element);
      });
      this.listDonnerCotation.push(donneDeCotation);
    },
    remplireDataCotationComplex(numCompteur, autreData, FRNaux) {
      let arrayTemp = [];
      this.nbrMonth = this.toutLesDonneesEnedis.mesuresInfo[0].nbrMonth;
      if (
        this.toutLesDonneesEnedis.mesuresInfo[0].result == "notValide" &&
        this.toutLesDonneesEnedis.donneTechniqueInfo[0].result == "notValide"
      ) {
        this.errorEnedis = true;
      } else {
        this.errorEnedis = false;
        this.enedisRecherche = true;
      }
      let donneDeCotation = {};

      this.enedisRecherche = true;
      donneDeCotation.resultatEnedis = this.toutLesDonneesEnedis;
      arrayTemp = [...FRNaux];
      this.defaulttousLesAutreFournisseur = [...FRNaux];
      for (var j = 0; j < this.defaulttousLesAutreFournisseur.lenght; j++) {
        if (
          this.defaulttousLesAutreFournisseur[j]["typeOffre"].indexOf("pré-écrêté") != -1
        ) {
          if (this.defaulttousLesAutreFournisseur[j]["typeOffre"].indexOf("%") != -1) {
            this.defaulttousLesAutreFournisseur[j]["Classique"] = [""];
            this.defaulttousLesAutreFournisseur[j][
              "preEcrete"
            ] = this.defaulttousLesAutreFournisseur[j]["typeOffre"]
              .split("pré-écrêté")[1]
              .split("%")[0]
              .replace(" ", "");
          } else {
            this.defaulttousLesAutreFournisseur[j]["Classique"] = ["Classique"];
            this.defaulttousLesAutreFournisseur[j]["preEcrete"] = "0";
          }
          this.defaulttousLesAutreFournisseur[j]["typeOffre"] = "pré-écrêté";
        }
      }
      if (this.toutLesDonneesEnedis.mesuresInfo[0].result === "valide") {
        for (var j = 0; j < arrayTemp.length; j++) {
          if (arrayTemp[j]["typeOffre"].indexOf("pré-écrêté") != -1) {
            if (arrayTemp[j]["typeOffre"].indexOf("%") != -1) {
              arrayTemp[j]["Classique"] = [""];
              arrayTemp[j]["preEcrete"] = arrayTemp[j]["typeOffre"]
                .split("pré-écrêté")[1]
                .split("%")[0]
                .replace(" ", "");
            } else {
              arrayTemp[j]["Classique"] = ["Classique"];
              arrayTemp[j]["preEcrete"] = "0";
            }
            arrayTemp[j]["typeOffre"] = "pré-écrêté";
          }
          arrayTemp[j].optionTarifaire = this.toutLesDonneesEnedis.mesuresInfo[0][
            "dataParMonth"
          ][0]["typeCompteur"];
        }
        this.resultatEnedisMesure = true;
        if ("HP" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HP.somme;
        } else {
          donneDeCotation.CAHP = null;
        }
        if ("HC" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHC = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HC.somme;
        } else {
          donneDeCotation.CAHC = null;
        }
        if ("HPH" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHPH = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HPH.somme;
        } else {
          donneDeCotation.CAHPH = null;
        }
        if ("HCH" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHCH = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HCH.somme;
        } else {
          donneDeCotation.CAHCH = null;
        }
        if ("HPE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHPE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HPE.somme;
        } else {
          donneDeCotation.CAHPE = null;
        }
        if ("HCE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAHCE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.HCE.somme;
        } else {
          donneDeCotation.CAHCE = null;
        }
        if ("Pointe" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.Pointe.somme;
        }
        if ("POINTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.POINTE.somme;
        }
        if ("PTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CAP = this.toutLesDonneesEnedis.mesuresInfo[0].donne.PTE.somme;
        }
        if (
          !("Pointe" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) &&
          !("POINTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) &&
          !("PTE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne)
        ) {
          donneDeCotation.CAP = null;
        }
        if ("BASE" in this.toutLesDonneesEnedis.mesuresInfo[0].donne) {
          donneDeCotation.CABASE = this.toutLesDonneesEnedis.mesuresInfo[0].donne.BASE.somme;
        } else {
          donneDeCotation.CABASE = null;
        }
      } else {
        this.resultatEnedisMesure = false;
        donneDeCotation.CAHP = null;
        donneDeCotation.CAHC = null;
        donneDeCotation.CAHPH = null;
        donneDeCotation.CAHCH = null;
        donneDeCotation.CAHPE = null;
        donneDeCotation.CAHCE = null;
        donneDeCotation.CAP = null;
        donneDeCotation.CAP = null;
        donneDeCotation.CABASE = null;
      }
      donneDeCotation["parametreCompteur"] =
        this.toutLesDonneesEnedis.parametreDeCompteur || "";
      if (this.toutLesDonneesEnedis.donneTechniqueInfo[0].result === "valide") {
        this.parametreCompteur = this.toutLesDonneesEnedis.parametreDeCompteur;
        if (
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur === "" ||
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur == "Résilié"
        ) {
          this.resultatEnedisTechnique = false;
        } else {
          this.resultatEnedisTechnique = true;
        }
        if (
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur != "" &&
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.kva != ""
        ) {
          donneDeCotation.optionTarifaire = this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.typeCompteur;
          donneDeCotation.puissanceSouscrite = this.toutLesDonneesEnedis.donneTechniqueInfo[0].data.kva;
        } else {
          donneDeCotation.optionTarifaire = null;
          donneDeCotation.puissanceSouscrite = null;
        }
        // get tout les kva

        donneDeCotation.kvaHp =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HP || "";

        donneDeCotation.kvaHc =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HC || "";

        donneDeCotation.kvaHce =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HCE || "";

        donneDeCotation.kvaHpe =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HPE || "";

        donneDeCotation.kvaHch =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HCH || "";

        donneDeCotation.kvaHph =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.HPH || "";

        donneDeCotation.kvaBase =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.BASE || "";

        donneDeCotation.kvaPte =
          this.toutLesDonneesEnedis.donneTechniqueInfo[0].data?.PTE || "";
      } else {
        this.parametreCompteur = "";
        this.resultatEnedisTechnique = false;
        donneDeCotation.kvaHp = "";

        donneDeCotation.kvaHc = "";

        donneDeCotation.kvaHce = "";

        donneDeCotation.kvaHpe = "";

        donneDeCotation.kvaHch = "";

        donneDeCotation.kvaHph = "";

        donneDeCotation.kvaBase = "";

        donneDeCotation.kvaPte = "";
      }
      if (autreData != false) {
        if (autreData.result == true) {
          const dateDebutFormatted = this.dateFormatMinus(autreData.dateDebut);
          const dateFinFormatted = this.dateFormatMinus(autreData.dateFin);
          this.dateDebut = dateDebutFormatted;
          this.dateFin = dateFinFormatted;
          donneDeCotation.dateDebut = dateDebutFormatted;
          donneDeCotation.dateFin = dateFinFormatted;
          donneDeCotation.marge = this.marge;
          donneDeCotation.margeAbo = this.margeAbo;
        }
      } else {
        donneDeCotation.dateDebut = this.dateDebut;
        donneDeCotation.dateFin = this.dateFin;
        donneDeCotation.marge = this.marge;
        donneDeCotation.margeAbo = this.margeAbo;
      }
      if (donneDeCotation.parametreCompteur == "C3") {
        donneDeCotation.sommeConsomation =
          donneDeCotation.CAHCH +
          donneDeCotation.CAHPH +
          donneDeCotation.CAHPE +
          donneDeCotation.CAHCE +
          donneDeCotation.CAP;
      } else if (
        donneDeCotation.parametreCompteur == "C4" ||
        donneDeCotation.parametreCompteur == "C5C4"
      ) {
        donneDeCotation.sommeConsomation =
          donneDeCotation.CAHCH +
          donneDeCotation.CAHPH +
          donneDeCotation.CAHPE +
          donneDeCotation.CAHCE;
      } else if (donneDeCotation.parametreCompteur == "C5HP") {
        donneDeCotation.sommeConsomation = donneDeCotation.CAHC + donneDeCotation.CAHP;
      } else if (donneDeCotation.parametreCompteur == "C5BASE") {
        donneDeCotation.sommeConsomation = donneDeCotation.CABASE || 0;
      }
      donneDeCotation.resultatEnedisTechnique = this.resultatEnedisTechnique;
      donneDeCotation.resultatEnedisMesure = this.resultatEnedisMesure;
      donneDeCotation["numCompteur"] = numCompteur;
      donneDeCotation["typeTraitementCompteur"] = "complex";
      arrayTemp.forEach((element) => {
        this.tousLesAutreFournisseur.push(element);
      });


      return donneDeCotation;
    },
    async getCompteurData() {
      this.dialog = true;
      this.loading = true;
      this.error = false;
      this.messageDialogeError = "";
      this.messageDialogeSucces = "";
      await this.getAllConsommation();
      this.dialog = false;
      this.loading = false;
    },
    getServiceCategory(compteurLine) {
      return compteurLine?.resultatEnedis?.donneTechniqueInfo[0]?.data?.["soapenv:Envelope"]?.["soap:Body"]?.["ns8:consulterDonneesPointResponse"]?.point?.situationContractuelle?.clientFinal?.categorie?.libelle || null;
    },
    async calculer() {
      if (new Date(this.dateDebut).getTime() >= new Date(this.dateFin).getTime()) {
        this.errorDateDeFin = true;
      } else {
        this.errorDateDeFin = false;
      }
      if (!this.$refs.formGeneral.validate()) {
        return false;
      }
      this.errorDateDeFin = false;
      this.dialog = true;
      this.loading = true;
      this.messageDialogeError = "";
      this.messageDialogeSucces = "";
      this.error = false;
      this.renitialiserLaListeDeResultat();
      this.$refs.formGeneral.validate();
      if (this.$refs.formGeneral.validate()) {
        console.log("this.listDonnerCotation", this.listDonnerCotation);
        await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "MultipleCalculeCoutProElec/",
          method: "POST",
          data: {
            donneDeCotation: this.listDonnerCotation,
            token: this.getToken("token"),
            parametreCompteur: this.parametreCompteur,
            siret: this.siret,
            autreFournisseur: this.tousLesAutreFournisseur,
          },
        })
          .then((res) => {
            if (res.data.result === "permission") {
              localStorage.setItem("vueAfficher", "particulier");
              localStorage.removeItem("vendeurName");
              localStorage.removeItem("typeUser");
              localStorage.removeItem("token");
              this.$router.push("/login");
            }

            let propositionCompteur = [];
            for (let i = 0; i < this.listCompteurSelected.length; i++) {
              let listProposition = res.data[this.listCompteurSelected[i]];
              propositionCompteur.push({
                NumCompteur: this.listCompteurSelected[i],
                resultat: listProposition,
              });
            }

            this.id_historique_cotation = res.data.historiqueId;
            this.$emit("sendDataToParent", {
              infosCompteur: res.data,
              donneDeCotation: null,
              optionTarifaire: null,
              parametreCompteur: null,
              Propositions: propositionCompteur, //Propositions: res.data.result,
              SocieteData: res.data.dataSociete,
              enedisData: res.data.dataEnedis,
              numCompteur: res.data.numCompteur,
              turpeData: res.data.dataTurpe,
              taxeData: res.data.dataTaxe,
              typeCompteur: res.data.typeCompteur,
              fournisseurActuelle: res.data.actuelle,
              selected: [],
              listCompteur: [...this.listCompteur], //this.listCompteurSelected, //
              donnerCompteur: res.data.donnerCompteur,
              id_historique_cotation: this.id_historique_cotation,
              donnerCompteur: res.data.donnerCompteur,
              date_debut: this.dateDebut,
              marge: this.marge,
            });
            this.dialog = false;
            this.loading = false;
          })
          .catch((err) => {
            this.error = true;
            this.loading = false;
            console.log(err);
            this.messageDialogeError =
              "une erreur s'est produite lors du calcul du cotation";
          });
      }
    },
    numCompteurChanged() {
      var itemSelected = this.listDonnerCotation.find(
        (item) => item.numCompteur == this.autreFournisseur.numCompteur
      );
      this.optionTarifaire = itemSelected.optionTarifaire;
      this.parametreCompteur = itemSelected.parametreCompteur;
      this.autreFournisseur.parametreCompteur = itemSelected.parametreCompteur;
    },
    supprimerFournisseur(index) {
      this.renitialiserLaListeDeResultat();
      this.tousLesAutreFournisseur.splice(index, 1);
      this.defaulttousLesAutreFournisseur.splice(index, 1);

      const foundActuelle = this.tousLesAutreFournisseur.some(
        (item) => item.typeFournisseur == "Actuelle"
      );
      if (foundActuelle) {
        this.fournisseurActuelle = true;
      } else {
        this.fournisseurActuelle = false;
      }
    },
    AjouterFournisseur(index = -1) {
      this.renitialiserLaListeDeResultat();
      this.$refs.formActuelle.validate();
      if (this.autreFournisseur.multiYear) {
        this.erreurMultiYear = this.verifierAnneesAutreFournisseur();
        if (this.erreurMultiYear) {
          return;
        }
      }
      if (this.$refs.formActuelle.validate()) {
        const foundActuelle = this.tousLesAutreFournisseur.some(
          (item) => item.typeFournisseur == "Actuelle"
        );
        const isCurrentActuelle = this.autreFournisseur.typeFournisseur == "Actuelle";
        if (foundActuelle || isCurrentActuelle) {
          this.fournisseurActuelle = true;
        } else {
          this.fournisseurActuelle = false;
        }

        if (this.editFournisseur == true) {
          var d = {
            turpeInclus: this.autreFournisseur.turpeInclus,
            ajoutMarge: this.autreFournisseur.ajoutMarge || false,
            typeFournisseur: this.autreFournisseur.typeFournisseur,
            numCompteur: this.autreFournisseur.numCompteur,
            fournisseur: this.autreFournisseur.fournisseur,
            typeOffre: this.autreFournisseur.typeOffre,
            prixHPH: this.autreFournisseur.prixHPH,
            prixHCH: this.autreFournisseur.prixHCH,
            prixHPE: this.autreFournisseur.prixHPE,
            prixHCE: this.autreFournisseur.prixHCE,
            prixHP: this.autreFournisseur.prixHP,
            prixHC: this.autreFournisseur.prixHC,
            prixBASE: this.autreFournisseur.prixBASE,
            prixPOINTE: this.autreFournisseur.prixPOINTE,
            typeCapa: this.autreFournisseur.typeCapa,
            capaHPH: this.autreFournisseur.capaHPH,
            capaHCH: this.autreFournisseur.capaHCH,
            capaHPE: this.autreFournisseur.capaHPE,
            capaHCE: this.autreFournisseur.capaHCE,
            capaHP: this.autreFournisseur.capaHP,
            capaHC: this.autreFournisseur.capaHC,
            capaBASE: this.autreFournisseur.capaBASE,
            capaPOINTE: this.autreFournisseur.capaPOINTE,
            CEE: this.autreFournisseur.CEE,
            ABO: this.autreFournisseur.ABO,
            prixEnergieVerte: this.autreFournisseur.prixEnergieVerte,
            isEnergieVerte: this.autreFournisseur.isEnergieVerte,
            DUREE: this.autreFournisseur.DUREE,
            DUREE: this.autreFournisseur.DUREE,
            dateSaisie: this.todayDate,
            parametreCompteur: this.autreFournisseur.parametreCompteur,
            multiYear: !!this.autreFournisseur.multiYear,
            years: this.autreFournisseur.multiYear
              ? this.autreFournisseur.years.map((year) => ({ ...year, annee: parseInt(year.annee) }))
              : [],
          };
          d.optionTarifaire = this.optionTarifaire;
          if (this.autreFournisseur.typeOffre == "pré-écrêté") {
            if (this.autreFournisseur.Classique.indexOf("Classique") != -1) {
              d["typeOffre"] = "pré-écrêté Classique";
            } else {
              d["typeOffre"] =
                this.autreFournisseur.typeOffre +
                " " +
                this.autreFournisseur.preEcrete +
                "%";
            }
          } else {
            d["typeOffre"] = this.autreFournisseur.typeOffre;
          }
          this.tousLesAutreFournisseur.splice(index, 1);
          this.tousLesAutreFournisseur.push(d);
          if (this.autreFournisseur.typeFournisseur == "Actuelle") {
            for (var i = 0; i < this.tousLesAutreFournisseur.length; i++) {
              if (
                this.tousLesAutreFournisseur[i]["numCompteur"] ==
                  this.autreFournisseur["numCompteur"] &&
                i != this.tousLesAutreFournisseur.length - 1 &&
                this.tousLesAutreFournisseur[i]["typeFournisseur"] == "Actuelle"
              ) {
                this.tousLesAutreFournisseur[i]["typeFournisseur"] = "Fournisseur";
              }
            }
          }
        } else {
          // Multi-compteur add mode: create one entry per selected compteur
          var typeOffreFormatted = this.autreFournisseur.typeOffre;
          if (this.autreFournisseur.typeOffre == "pré-écrêté") {
            if (this.autreFournisseur.Classique.indexOf("Classique") != -1) {
              typeOffreFormatted = "pré-écrêté Classique";
            } else {
              typeOffreFormatted =
                this.autreFournisseur.typeOffre +
                " " +
                this.autreFournisseur.preEcrete +
                "%";
            }
          }

          for (const numCompteur of this.selectedCompteursMulti) {
            const compteurInfo = this.listDonnerCotation.find(c => c.numCompteur === numCompteur);
            const param = compteurInfo ? compteurInfo.parametreCompteur : "";
            const groupPrix = this.prixParGroupe[param] || {};

            var d = {
              turpeInclus: this.autreFournisseur.turpeInclus,
              ajoutMarge: this.autreFournisseur.ajoutMarge || false,
              typeFournisseur: this.autreFournisseur.typeFournisseur,
              numCompteur: numCompteur,
              fournisseur: this.autreFournisseur.fournisseur,
              typeOffre: typeOffreFormatted,
              prixHPH: groupPrix.prixHPH || null,
              prixHCH: groupPrix.prixHCH || null,
              prixHPE: groupPrix.prixHPE || null,
              prixHCE: groupPrix.prixHCE || null,
              prixHP: groupPrix.prixHP || null,
              prixHC: groupPrix.prixHC || null,
              prixBASE: groupPrix.prixBASE || null,
              prixPOINTE: groupPrix.prixPOINTE || null,
              typeCapa: groupPrix.typeCapa || "CAPA",
              capaHPH: groupPrix.capaHPH || null,
              capaHCH: groupPrix.capaHCH || null,
              capaHPE: groupPrix.capaHPE || null,
              capaHCE: groupPrix.capaHCE || null,
              capaHP: groupPrix.capaHP || null,
              capaHC: groupPrix.capaHC || null,
              capaBASE: groupPrix.capaBASE || null,
              capaPOINTE: groupPrix.capaPOINTE || null,
              CEE: this.autreFournisseur.CEE,
              ABO: this.autreFournisseur.ABO,
              prixEnergieVerte: this.autreFournisseur.prixEnergieVerte,
              isEnergieVerte: this.autreFournisseur.isEnergieVerte,
              DUREE: this.autreFournisseur.DUREE,
              parametreCompteur: param,
              optionTarifaire: compteurInfo ? compteurInfo.optionTarifaire : "",
              dateSaisie: this.todayDate,
              multiYear: !!this.autreFournisseur.multiYear,
              years: this.autreFournisseur.multiYear
                ? (groupPrix.years || []).map((year) => ({ ...year, annee: parseInt(year.annee) }))
                : [],
            };

            this.tousLesAutreFournisseur.push(d);
            this.defaulttousLesAutreFournisseur.push(d);

            // Demote other "Actuelle" entries for same compteur
            if (this.autreFournisseur.typeFournisseur == "Actuelle") {
              for (var i = 0; i < this.tousLesAutreFournisseur.length; i++) {
                if (
                  this.tousLesAutreFournisseur[i]["numCompteur"] == numCompteur &&
                  i != this.tousLesAutreFournisseur.length - 1 &&
                  this.tousLesAutreFournisseur[i]["typeFournisseur"] == "Actuelle"
                ) {
                  this.tousLesAutreFournisseur[i]["typeFournisseur"] = "Fournisseur";
                }
              }
            }
          }
        }
        this.resetFournisseurActuelle();
        this.$refs.formActuelle.resetValidation();
        this.openModalFornisseurActuelle = false;
        this.editFournisseur = false;
        this.autreFournisseur.numCompteur = "";
        this.annulerDonnerJpme();
        this.margeJpme = null;
      }
    },
    editFournisseurMethod(index) {
      this.editFournisseur = true;
      this.indexFournisseurEdited = index;
      var fournisseurToUpdate = this.tousLesAutreFournisseur[index];
      if (fournisseurToUpdate["typeOffre"].indexOf("pré-écrêté") != -1) {
        if (fournisseurToUpdate["typeOffre"].indexOf("%") != -1) {
          fournisseurToUpdate["Classique"] = [""];
          fournisseurToUpdate["preEcrete"] = fournisseurToUpdate["typeOffre"]
            .split("pré-écrêté")[1]
            .split("%")[0]
            .replace(" ", "");
        } else {
          fournisseurToUpdate["Classique"] = ["Classique"];
          fournisseurToUpdate["preEcrete"] = "0";
        }
        fournisseurToUpdate["typeOffre"] = "pré-écrêté";
      }
      if (!fournisseurToUpdate.ajoutMarge) {
        fournisseurToUpdate.ajoutMarge = false;
      }
      if (!("multiYear" in fournisseurToUpdate)) {
        this.$set(fournisseurToUpdate, "multiYear", false);
      }
      if (!Array.isArray(fournisseurToUpdate.years)) {
        this.$set(fournisseurToUpdate, "years", []);
      }
      this.erreurMultiYear = "";
      this.cacheAnneesAutreFournisseur = {};
      this.defaultAutreFournisseur = {
        ...fournisseurToUpdate,
        years: JSON.parse(JSON.stringify(fournisseurToUpdate.years)),
      };
      this.autreFournisseur = fournisseurToUpdate;

      this.$refs.formGeneral.validate();
      if (this.$refs.formGeneral.validate()) {
        this.openModalFornisseurActuelle = true;
      }
      this.numCompteurChanged();
    },
    closeModalHandleFournisseur() {
      this.annulerDonnerJpme();
      this.jpmeFileOuiNon = false;
      this.margeJpme = null;
      this.openModalFornisseurActuelle = false;
      this.editFournisseur = false;
      this.$refs.formActuelle.resetValidation();
      this.tousLesAutreFournisseur[
        this.indexFournisseurEdited
      ] = this.defaultAutreFournisseur;
      this.defaulttousLesAutreFournisseur[this.indexFournisseurEdited] = {
        ...this.defaultAutreFournisseur,
      };
      this.indexFournisseurEdited = -1;
      this.defaultAutreFournisseur = {
        typeFournisseur: "Fournisseur",
        turpeInclus: "non",
        ajoutMarge: false,
        numCompteur: "",
        Classique: ["Classique"],
        preEcrete: "0",
        fournisseur: null,
        typeOffre: "",
        prixHPH: null,
        prixHCH: null,
        prixHPE: null,
        prixHCE: null,
        prixHP: null,
        prixHC: null,
        prixBASE: null,
        prixPOINTE: null,
        typeCapa: "CAPA",
        capaHPH: null,
        capaHCH: null,
        capaHPE: null,
        capaHCE: null,
        capaHP: null,
        capaHC: null,
        capaBASE: null,
        capaPOINTE: null,
        CEE: null,
        ABO: null,
        prixEnergieVerte:null,
        isEnergieVerte: false,
        DUREE: null,
        multiYear: false,
        years: [],
      };
      this.erreurMultiYear = "";
      this.cacheAnneesAutreFournisseur = {};
      this.autreFournisseur = this.defaultAutreFournisseur;
      this.selectedCompteursMulti = [];
      this.dialogStep = 1;
      this.prixParGroupe = {};
    },
    calculeSommeCotation(donneDeCotation) {
      if (donneDeCotation.parametreCompteur == "C3") {
        var hch = 0;
        var hph = 0;
        var hce = 0;
        var hpe = 0;
        var pointe = 0;
        try {
          if (!isNaN(donneDeCotation.CAHCH)) {
            hch = parseFloat(donneDeCotation.CAHCH);
          } else {
            hch = 0;
          }
        } catch (error) {
          hch = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHPH)) {
            hph = parseFloat(donneDeCotation.CAHPH);
          } else {
            hph = 0;
          }
        } catch (error) {
          hph = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHPE)) {
            hpe = parseFloat(donneDeCotation.CAHPE);
          } else {
            hpe = 0;
          }
        } catch (error) {
          hpe = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHCE)) {
            hce = parseFloat(donneDeCotation.CAHCE);
          } else {
            hce = 0;
          }
        } catch (error) {
          hce = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAP)) {
            pointe = parseFloat(donneDeCotation.CAP);
          } else {
            pointe = 0;
          }
        } catch (error) {
          pointe = 0;
        }
        donneDeCotation.sommeConsomation = hch + hph + hce + hpe + pointe;
      } else if (
        donneDeCotation.parametreCompteur == "C4" ||
        donneDeCotation.parametreCompteur == "C5C4"
      ) {
        var hch = 0;
        var hph = 0;
        var hce = 0;
        var hpe = 0;
        var pointe = 0;
        try {
          if (!isNaN(donneDeCotation.CAHCH)) {
            hch = parseFloat(donneDeCotation.CAHCH);
          } else {
            hch = 0;
          }
        } catch (error) {
          hch = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHPH)) {
            hph = parseFloat(donneDeCotation.CAHPH);
          } else {
            hph = 0;
          }
        } catch (error) {
          hph = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHPE)) {
            hpe = parseFloat(donneDeCotation.CAHPE);
          } else {
            hpe = 0;
          }
        } catch (error) {
          hpe = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHCE)) {
            hce = parseFloat(donneDeCotation.CAHCE);
          } else {
            hce = 0;
          }
        } catch (error) {
          hce = 0;
        }
        donneDeCotation.sommeConsomation = hch + hph + hce + hpe;
      } else if (donneDeCotation.parametreCompteur == "C5HP") {
        var hc = 0;
        var hp = 0;
        try {
          if (!isNaN(donneDeCotation.CAHC)) {
            hc = parseFloat(donneDeCotation.CAHC);
          } else {
            hc = 0;
          }
        } catch (error) {
          hc = 0;
        }
        try {
          if (!isNaN(donneDeCotation.CAHP)) {
            hp = parseFloat(donneDeCotation.CAHP);
          } else {
            hp = 0;
          }
        } catch (error) {
          hp = 0;
        }
        donneDeCotation.sommeConsomation = hc + hp;
      } else if (donneDeCotation.parametreCompteur == "C5BASE") {
        var base = 0;
        try {
          if (!isNaN(donneDeCotation.CABASE)) {
            base = parseFloat(donneDeCotation.CABASE);
          } else {
            base = 0;
          }
        } catch (error) {
          base = 0;
        }
        donneDeCotation.sommeConsomation = base;
      }
    },
  },
  computed: {
    groupedParametreCompteurs() {
      if (this.editFournisseur || this.selectedCompteursMulti.length === 0) return [];
      const seen = {};
      const result = [];
      for (const numCompteur of this.selectedCompteursMulti) {
        const item = this.listDonnerCotation.find(c => c.numCompteur === numCompteur);
        if (item && !seen[item.parametreCompteur]) {
          seen[item.parametreCompteur] = true;
          result.push(item.parametreCompteur);
        }
      }
      return result;
    },
    fieldsPerParametre() {
      return {
        C3: { prix: ['prixPOINTE', 'prixHPH', 'prixHCH', 'prixHPE', 'prixHCE'], capa: ['capaPOINTE', 'capaHPH', 'capaHCH', 'capaHPE', 'capaHCE'] },
        C4: { prix: ['prixHPH', 'prixHCH', 'prixHPE', 'prixHCE'], capa: ['capaHPH', 'capaHCH', 'capaHPE', 'capaHCE'] },
        C5C4: { prix: ['prixHPH', 'prixHCH', 'prixHPE', 'prixHCE'], capa: ['capaHPH', 'capaHCH', 'capaHPE', 'capaHCE'] },
        C5HP: { prix: ['prixHP', 'prixHC'], capa: ['capaHP', 'capaHC'] },
        C5BASE: { prix: ['prixBASE'], capa: ['capaBASE'] },
      };
    },
    fieldLabels() {
      return {
        prixPOINTE: '(P)', prixHPH: '(HPH)', prixHCH: '(HCH)', prixHPE: '(HPE)', prixHCE: '(HCE)',
        prixHP: '(HP)', prixHC: '(HC)', prixBASE: '(BASE)',
        capaPOINTE: '(P)', capaHPH: '(HPH)', capaHCH: '(HCH)', capaHPE: '(HPE)', capaHCE: '(HCE)',
        capaHP: '(HP)', capaHC: '(HC)', capaBASE: '(BASE)',
      };
    },
    getPropositionSiretOrName() {
      this.listCompteurSelected = [];
      this.listBodyArray = [];
      this.Propositions = [];
      if (this.Propositions.length == 0) {
        this.renitialiserLaListeDeResultat();
      }
      this.listCompteur = [];
      this.enedisRecherche = false;
      this.vraiSiret = false;
      if (this.valueRechercheSiret != "") {
        var formData = new FormData();
        formData.append("siret", this.valueRechercheSiret);
        formData.append("token", this.getToken("token"));
        this.isCompteursLoading = true;
        axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getPropositionSociete/",
          method: "POST",
          data: formData,
        }).then((res) => {
          this.listSociete = res.data.result;
        });
      } else {
        this.listSociete = [];
      }
      return true;
    },
  },
};
</script>
<style scoped>
::v-deep .smallradio .v-label {
  font-size: 12px;
  margin: 0;
  padding: 0;
}
.table-prix-annees-wrapper {
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin: 8px 0;
}
.table-prix-annees {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.table-prix-annees th {
  background-color: #f5f6f8;
  color: #3c4858;
  font-weight: 600;
  text-align: center;
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  white-space: nowrap;
}
.table-prix-annees td {
  border: 1px solid #e0e0e0;
  padding: 4px 6px;
  min-width: 90px;
}
.table-prix-annees td.annee {
  color: #2562eb;
  font-weight: 600;
  min-width: 60px;
  padding-left: 12px;
}
.table-prix-annees ::v-deep .v-text-field input {
  text-align: center;
}
.table-prix-annees.lecture {
  background-color: white;
}
.table-prix-annees.lecture td {
  text-align: center;
  padding: 8px 10px;
  color: #1a1a1a;
}
.table-prix-annees.lecture td.annee {
  text-align: left;
}
.table-compteurs-wrapper {
  overflow: auto;
}
.table-compteurs-wrapper table th,
.table-compteurs-wrapper table td {
  padding-left: 4px;
  padding-right: 4px;
}

.v-subheader {
  font-size: large;
  font-weight: 300;
  color: black;
  padding: 0px;
}

::v-deep .v-label {
  margin: 0px;
}

@media only screen and (max-width: 600px) {
  .v-subheader {
    font-size: medium;
    margin-top: 10px;
  }
}

@media only screen and (max-width: 1260px) {
  .responsive-margin {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 500px) {
  .responsiveClass {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .reponsiveBtn {
    margin: 0px;
  }

  .responsiveGroupButton {
    display: flex;
    flex-direction: column;
  }

  ::v-deep .marginBtn {
    margin-bottom: 10px !important;
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 510px) {
  .v-subheader {
    font-size: 1em;
  }

  .v-dialog > .v-card > .v-card__title {
    font-size: 0.7em;
  }
}

@media screen and (max-width: 300px) {
  .v-dialog > .v-card > .v-card__title {
    font-size: 0.7em;
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>

<style scoped>
.jpme-prices-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.jpme-price-card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  padding: 20px 20px;
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  box-shadow: 0px 4px 8px 0px #e3e3e3;
}
.jpme-price-block {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}
.jpme-price-item {
  width: 140px;
}
.category-info {
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
  font-style: italic;
}
</style>
